import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "d-flex height-100 width-100" }
const _hoisted_2 = {
  class: "taggy-flow-canvas-shell d-flex flex-column height-100",
  "data-taggy-flow-canvas": ""
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { id: "open-output-popup-dialog" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-items-center justify-content-center width-100 height-100"
}
const _hoisted_5 = {
  key: 0,
  class: "d-flex flex-column align-items-center justify-content-center"
}
const _hoisted_6 = { class: "card border-0 background-fb" }
const _hoisted_7 = { class: "card-header header-label d-flex flex-row justify-content-between align-items-center" }
const _hoisted_8 = { class: "card-body d-flex flex-column overflow-auto font-size-14" }
const _hoisted_9 = {
  key: 0,
  class: "margin-top-10 d-flex justify-content-between"
}
const _hoisted_10 = { class: "margin-top-10" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = {
  key: 0,
  class: "warning-div"
}
const _hoisted_13 = { class: "warning-text" }
const _hoisted_14 = { class: "margin-top-10" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_16 = {
  key: 0,
  class: "warning-div"
}
const _hoisted_17 = { class: "warning-text" }
const _hoisted_18 = { class: "margin-top-10 d-flex align-items-start justify-content-between" }
const _hoisted_19 = { class: "d-flex flex-column align-items-start" }
const _hoisted_20 = { class: "d-flex flex-column align-items-end" }
const _hoisted_21 = {
  key: 1,
  class: "margin-top-20 d-flex align-items-center justify-content-between"
}
const _hoisted_22 = { class: "d-flex align-items-center gap-1" }
const _hoisted_23 = {
  key: 2,
  class: "margin-top-20 d-flex justify-content-between"
}
const _hoisted_24 = {
  key: 0,
  class: "d-flex flex-column align-items-start gap-2"
}
const _hoisted_25 = {
  key: 1,
  class: "d-flex flex-column align-items-end gap-2"
}
const _hoisted_26 = {
  key: 3,
  class: "margin-top-20 d-flex justify-content-between"
}
const _hoisted_27 = {
  key: 0,
  class: "d-flex flex-column align-items-start gap-2"
}
const _hoisted_28 = {
  key: 1,
  class: "d-flex flex-column align-items-end gap-2"
}
const _hoisted_29 = {
  key: 4,
  class: "margin-top-20 d-flex flex-row align-items-start gap-2"
}
const _hoisted_30 = {
  key: 5,
  class: "margin-top-10 d-flex flex-column"
}
const _hoisted_31 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_32 = ["src"]
const _hoisted_33 = {
  key: 6,
  class: "margin-top-10 d-flex flex-column"
}
const _hoisted_34 = { style: {"float":"left"} }
const _hoisted_35 = ["src"]
const _hoisted_36 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_37 = ["src"]
const _hoisted_38 = {
  key: 7,
  class: "margin-top-10 d-flex flex-column gap-2"
}
const _hoisted_39 = {
  key: 8,
  class: "margin-top-20"
}
const _hoisted_40 = { class: "bold" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_42 = {
  key: 9,
  class: "margin-top-10 d-flex flex-column"
}
const _hoisted_43 = { class: "d-flex w-100" }
const _hoisted_44 = { style: {"float":"left"} }
const _hoisted_45 = {
  key: 10,
  class: "margin-top-10 d-flex flex-column align-items-start gap-2"
}
const _hoisted_46 = { class: "d-flex flex-row align-items-start gap-2" }
const _hoisted_47 = { class: "margin-top-10 d-flex justify-content-between align-items-center w-100" }
const _hoisted_48 = { class: "d-flex align-items-center gap-2" }
const _hoisted_49 = {
  class: "d-flex justify-content-between align-items-center w-100",
  style: {"padding":"4px 0"}
}
const _hoisted_50 = { class: "d-flex align-items-center gap-1" }
const _hoisted_51 = { class: "scrollable-tooltip-content" }
const _hoisted_52 = {
  key: 13,
  class: "margin-top-10 d-flex flex-column align-items-start gap-2"
}
const _hoisted_53 = { class: "d-flex flex-row align-items-start gap-2" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_55 = { class: "margin-top-10 d-flex flex-column" }
const _hoisted_56 = {
  key: 14,
  class: "margin-top-10 d-flex flex-column gap-2"
}
const _hoisted_57 = { class: "d-flex flex-column gap-2" }
const _hoisted_58 = /*#__PURE__*/_createElementVNode("strong", null, /*#__PURE__*/_toDisplayString("Notify Users"), -1)
const _hoisted_59 = {
  class: "emailValidation",
  id: "invalidEmail"
}
const _hoisted_60 = { class: "card border-0 background-fb" }
const _hoisted_61 = { class: "d-flex flex-row justify-content-end" }
const _hoisted_62 = { class: "card-body d-flex flex-column overflow-auto font-size-14" }
const _hoisted_63 = { class: "d-flex justify-content-between" }
const _hoisted_64 = { class: "d-flex align-items-center justify-content-end gap-2 add-btn-wrapper" }
const _hoisted_65 = {
  key: 1,
  class: "d-flex align-items-center full-width justify-content-center margin-top-10"
}
const _hoisted_66 = { class: "udv-field-column" }
const _hoisted_67 = { class: "udv-field-column" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("span", { class: "udv-action-column" }, null, -1)
const _hoisted_69 = ["id"]
const _hoisted_70 = ["id"]
const _hoisted_71 = { class: "d-flex flex-column align-items-center justify-content-center margin-top-10 udv-action-column" }
const _hoisted_72 = ["onClick"]
const _hoisted_73 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_74 = { class: "card-header header-drawer d-flex flex-row align-items-center justify-content-between" }
const _hoisted_75 = { class: "card-body filter-condition-body overflow-auto" }
const _hoisted_76 = { class: "filter-condition-panel" }
const _hoisted_77 = { class: "d-flex justify-content-end align-items-center margin-top-10 filter-condition-actions" }
const _hoisted_78 = { class: "card-header header-label d-flex flex-row justify-content-between align-items-center" }
const _hoisted_79 = { class: "card-body d-flex flex-column overflow-auto font-size-14" }
const _hoisted_80 = { class: "tree-container" }
const _hoisted_81 = { class: "custom-tree-node" }
const _hoisted_82 = { key: 1 }
const _hoisted_83 = {
  key: 2,
  style: {"width":"100%"}
}
const _hoisted_84 = { class: "right-menu-bar height-100 d-flex flex-column justify-content-between" }
const _hoisted_85 = { class: "d-flex flex-column" }
const _hoisted_86 = {
  key: 0,
  class: "nav flex-column nav-tabs no-border height-100"
}
const _hoisted_87 = { class: "nav-link tab-link d-flex align-items-center" }
const _hoisted_88 = { class: "nav-link tab-link d-flex align-items-center" }
const _hoisted_89 = ["onClick"]
const _hoisted_90 = { class: "nav-link tab-link d-flex align-items-center" }
const _hoisted_91 = {
  key: 1,
  class: "nav flex-column nav-tabs no-border height-100"
}
const _hoisted_92 = { class: "nav-link tab-link d-flex align-items-center" }
const _hoisted_93 = { class: "nav flex-column nav-tabs no-border height-100" }
const _hoisted_94 = { class: "nav-link tab-link d-flex align-items-center" }
const _hoisted_95 = { class: "nav flex-column nav-tabs no-border height-100" }
const _hoisted_96 = { class: "nav-link tab-link d-flex align-items-center" }
const _hoisted_97 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_98 = {
  key: 0,
  class: "d-flex flex-column"
}
const _hoisted_99 = {
  key: 0,
  class: "d-flex flex-column align-items-center justify-content-center"
}
const _hoisted_100 = ["disabled"]
const _hoisted_101 = ["disabled"]
const _hoisted_102 = /*#__PURE__*/_createElementVNode("div", { class: "button-separator" }, null, -1)
const _hoisted_103 = ["disabled"]
const _hoisted_104 = {
  key: 2,
  class: "button-separator"
}
const _hoisted_105 = ["disabled"]
const _hoisted_106 = /*#__PURE__*/_createElementVNode("div", { class: "button-separator" }, null, -1)
const _hoisted_107 = ["disabled"]
const _hoisted_108 = /*#__PURE__*/_createElementVNode("div", { class: "button-separator" }, null, -1)
const _hoisted_109 = ["disabled"]
const _hoisted_110 = ["disabled"]
const _hoisted_111 = { class: "loader-div-40" }
const _hoisted_112 = ["src"]
const _hoisted_113 = {
  key: 0,
  style: {"position":"relative"}
}
const _hoisted_114 = /*#__PURE__*/_createElementVNode("div", { id: "proceed-step-popup-dialog" }, null, -1)

import {
  computed,
  defineAsyncComponent,
  nextTick,
  onBeforeUnmount,
  onMounted,
  onUnmounted,
  provide,
  reactive,
  ref,
  watch,
} from "vue";
import { useVueFlow } from "@vue-flow/core";
import { cloneDeep, debounce, isEqual, uniqueId } from "lodash-es";
import { TYPE } from "vue-toastification";
import {
  ElButton,
  ElCheckbox,
  ElColorPicker,
  ElInput,
  ElOption,
  ElSelect,
  ElSwitch,
  ElTag,
  ElTooltip,
  ElTree,
  ElScrollbar,
  ElDivider,
} from "element-plus";
import { v4 as uuidv4 } from "uuid";
import {
  addFlow,
  connectWebsocket,
  convertDate,
  editFlow,
  addSourceAndTarget,
  Flow,
  getConnections,
  getFlow,
  getModifiedUser,
  isRunning,
  revertFlow,
  startFlow,
  statusColor,
  stopFlow,
  getSystemVariables,
  getExpressionDetails,
  getConfigurationFramework,
  updateConfigurationFramework,
  getOrganizationsExecutions,
  getOrganizationDefault,
  getExecutionProperties,
  getCreatedByByFlowIdAndVersion,
  getCreatedAtByFlowIdAndVersion,
  validateCronExpression,
  getTenantDefault,
  convertFlowToNewUi,
  isAIFlowReportingEnabledForTenant,
  isAIWizardEnabledForTenant,
  isAISkillGeneratorEnabledForTenant,
  generateFlowSkill,
  getFlowSkillStatus,
  persistSkillGenJob,
  clearSkillGenJob,
  getPersistedSkillGenJob,
  getProperty,
  generateAIReport,
  updateAIReport,
  getAIReport,
  checkAIReportExists,
} from "@/flow/services/flow.service";
import { getOrganizationsConnectorList } from "@/connection/services/connection.service";
import { confirmAndRemoveUdv } from "@/flow/services/udv.service";
import { updateConfiguraitonSettings } from "@/settings/services/settings.service";
import { getUserById } from "@/user/services/user.service";
import { showAlert, showConfirm } from "@/core/popup";
import i18n from "@/core/i18n/i18n";
import { hasPermission, updateSinglePreference, authInfo } from "@/core/auth";
import { changeListItemOfBreadcrumb } from "@/core/layout";
import { ASSETS_BASE_URL, DEFAULT_LOGO, getResolution } from "@/core/logo";
import { getPreferenceValue } from "@/core/preferences/preferences";
import { isAnyRouteHasNotFilterProp } from "@/flow/validations/isAnyRouteHasNotFilterProp";
import { flushFlowInputs } from "@/flow/application/conditionInputFlushRegistry";
import { findInvalidStepFilterIndex } from "@/flow/validations/findInvalidStepFilterIndex";
import { isAnyStepHasNotConnectorProp } from "@/flow/validations/isAnyStepHasNotConnectorProp";
import { useActivity } from "@/flow/application/activity";
import { getOutputListForAllStep } from "@/flow/utils/getOutputListForAllStep";
import { useAddPositionToStep } from "@/flow/application/useAddPositionToStep";
import { sortOutputItemsByGraphOrder } from "@/flow/application/computeAvailableOutput";
import { useStepDisplay } from "@/core/composables/useStepDisplay";
import {
  assignStepNumber,
  migrateStepNumbers,
  overrideIxForBackend,
  restoreStepNumbersFromIx,
} from "@/flow/utils/stepNumberUtils";
import { PREFER_ORIG_ID_OUTPUT_REFERENCES_KEY } from "@/flow/utils/outputReferenceUtils";
import { syncOutputIndexReferencesNewUi } from "@/flow/utils/syncOutputIndexReferencesNewUi";
import {
  preserveUdvChangeMaps,
  stripUdvValueOnlyRows,
} from "@/flow/utils/preserveUdvChangeMaps";
import { AddedStep, ChangedStep, RemovedStep } from "@/flow/types";
import { Flow as FlowType } from "@/flow/domain/flow";
import { findStepByOrigId } from "@/flow/utils/nodeUtils";
import { normalizeLoopConfig } from "@/flow/utils/loopUtils";
import {
  evaluateParallelThreadBudget,
  ParallelThreadBudgetResult,
} from "@/flow/services/parallelProcessing.service";
import { collectAllRouterStepOrigIds } from "@/flow/utils/routerUtils";
import { findStepForSelection } from "@/flow/utils/stepSelectionUtils";
import {
  applyHorizontalShrinkShift,
  collectStructureSteps,
  compactRouterSiblingBranchesLeft,
  getListBounds,
  getStepsBounds,
  getStructureRange,
  ROUTE_VERTICAL_GAP,
  shiftRouteSiblingBranchesUp,
  shiftStructureSteps,
  STRUCTURE_HORIZONTAL_GAP,
} from "@/flow/utils/incrementalAddShift";
import { applyOrganizedLayout, getOrigKey } from "@/flow/utils/organizedLayout";
import {
  compactDetachedGroupLayout,
  createDetachedLayoutPlan,
  getVisibleConnectedStepOrigIds,
  restoreDetachedLayoutFields,
  withFilteredRouteSteps,
} from "@/flow/utils/detachedLayoutUtils";
import FlowDiagram from "@/flow/components/vue-flow/FlowDiagram.vue";
import WizardDrawer from "@/flow/components/wizard/WizardDrawer.vue";
import FlowPreviewOverlay from "@/flow/components/wizard/FlowPreviewOverlay.vue";
import TaggyPromo from "@/flow/components/wizard/TaggyPromo.vue";
import {
  consumeWizardReopenAfterRefresh,
  initializeWizardSessionScope,
  resetPersistedWizardSession,
} from "@/flow/composables/useWizardSession";
import { buildWizardFlowSnapshot } from "@/flow/utils/wizardFlowSnapshot";
import type { WizardAutoDebugContext } from "@/flow/services/wizard.service";

import timezoneOffsets from "@/flow/utils/timezoneOffset";
import { currentRoute, router } from "@/core/router";
import { useRouter, useRoute, onBeforeRouteLeave } from "vue-router";
import { EventBus } from "@/eventBus";
import { getFlowLogZipById } from "@/dashboard/services/flow_log.service";
import WebsocketUrlProvider from "@/core/services/websocketUrl.provider";
import { faDownload } from "@fortawesome/free-solid-svg-icons";
import { getMetaoutputListForAllStep } from "../utils/getMetaoutputListForAllStep";
import {
  isSkillGenerationEnabled,
  restoreSkillGenerationToggle,
  saveSkillGenerationToggle,
} from "./skillGenerationToggle";

const FLOW_DIAGRAM_INITIAL_SYNC_IDLE_MS = 250;
const WIZARD_HISTORY_DRAWER_WIDTH = 450;
const FUNCTION_DRAWER_WIDTH = 450;
const FUNCTION_EXPRESSION_DRAWER_WIDTH = 600;
const EDIT_STEP_BASE_MIN_WIDTH = 520;
const CONDITION_BASE_MIN_WIDTH = 600;
const ROUTER_BASE_MIN_WIDTH = 600;
const WIZARD_BASE_MIN_WIDTH = 520;
const MAX_DRAWER_RENDER_WIDTH = 1500;

export default /*#__PURE__*/_defineComponent({
  __name: 'EditVueFlow',
  setup(__props) {

let skillGenPollIntervalMs = 15_000;
let skillGenPollTimeoutMs = 15 * 60 * 1000;

const EditStep = defineAsyncComponent(
  () => import(/* webpackPreload: true */ "@/flow/components/EditStep.vue")
);
const SimulateDialog = defineAsyncComponent(
  () => import("@/flow/components/SimulateDialog.vue")
);
const FlowVersions = defineAsyncComponent(
  () => import("@/flow/components/FlowVersions.vue")
);

provide(PREFER_ORIG_ID_OUTPUT_REFERENCES_KEY, true);
const EditRoute = defineAsyncComponent(
  () => import("@/flow/components/EditRoute.vue")
);
const EditLoop = defineAsyncComponent(
  () => import("@/flow/components/EditLoop.vue")
);
const Condition = defineAsyncComponent(
  () => import("@/flow/components/Condition.vue")
);
const EditDelay = defineAsyncComponent(
  () => import("@/flow/components/EditDelay.vue")
);
const Activities = defineAsyncComponent(
  () => import("@/activity/pages/Activities.vue")
);
const CronEditor = defineAsyncComponent(
  () => import("@/flow/components/cron-editor/pages/CronEditor.vue")
);
const OutputDataDialog = defineAsyncComponent(
  () => import("@/flow/components/OutputDataDialog.vue")
);

const { t } = i18n.global;
const wizardDrawerVisible = ref(false);
const wizardHistoryVisible = ref(false);
// Set by "Analyze with Wizard" from a simulate-step or run-flow process-log
// popup — both already produce a real, persisted, queryable activityId (see
// WorkflowInitializerServiceImpl.simulate/startFlow), so this reuses the exact
// same debug_agent auto-kickoff mechanism the Activities page uses.
const wizardAutoDebugContext = ref<WizardAutoDebugContext | null>(null);
const aiWizardEnabled = ref(false);
const aiSkillGeneratorEnabled = ref(false);
const skillGenerationEnabled = computed(() =>
  isSkillGenerationEnabled(flow.value?.skillGenerationEnabled)
);
const skillGenerationEnabledModel = computed({
  get: () => isSkillGenerationEnabled(flow.value?.skillGenerationEnabled),
  set: (val: boolean) => {
    if (flow.value) flow.value.skillGenerationEnabled = val;
    if (flowId.value) {
      saveSkillGenerationToggle(flowId.value, val);
    }
    onFlowChange();
  },
});
const isGeneratingSkill = ref(false);
const skillExists = ref(false);
const skillFlowVersion = ref<number | null>(null);
const isSkillUpToDate = computed(
  () =>
    skillExists.value &&
    skillFlowVersion.value !== null &&
    Number(skillFlowVersion.value) === Number(flow.value?.version) &&
    !isAnyChange.value
);
const canGenerateSkill = computed(
  () => !!flowId.value && flow.value?.version != null && !isAnyChange.value
);
let skillClient;
let skillPollInterval: ReturnType<typeof setInterval> | null = null;
const wizardDrawerRef = ref<InstanceType<typeof WizardDrawer> | null>(null);
const wizardPreviewActive = ref(false);
const wizardPreviewFlowSpec = ref<any>(null);
const wizardPreviewSubmitting = ref(false);
const wizardReviewActive = computed(
  () => wizardPreviewActive.value && wizardDrawerVisible.value
);
const connections = ref([]);
// Connectors that need no per-tenant configuration (connectionOptional) can be used as steps
// without a Connection. We surface them as synthetic, connection-shaped entries blended into the
// picker alongside real connections.
const connectors = ref([]);
const combinedConnections = computed(() => {
  const optional = (connectors.value || [])
    .filter((c: any) => c.connectionOptional)
    .map((c: any) => ({
      id: `connector:${c.connectorSpecId}`,
      name: c.name,
      active: true,
      connectionOptional: true,
      connector: {
        connectorSpecId: c.connectorSpecId,
        connectorType: c.connectorType,
        hasConsumer: c.hasConsumer,
        name: c.name,
      },
    }));
  return [...connections.value, ...optional];
});
const isVersionChanged = ref(false);
const steps = ref<any[]>([]);
const flowLines = ref<any[]>([]);
const allStep = ref<any[]>([]);
const flow = ref({
  name: "",
  active: true,
  scheduleType: "NONE",
  latest: true,
} as Flow);
const hasInvalidLoopBackConnection = ref(false);

function onInvalidLoopChange(hasInvalid: boolean) {
  hasInvalidLoopBackConnection.value = !!hasInvalid;
}

function openWizardDrawer() {
  if (!aiWizardEnabled.value) {
    return;
  }
  if (wizardDrawerVisible.value) {
    wizardDrawerVisible.value = false;
    return;
  }
  closeDrawer();
  userVariableVisible.value = false;
  configurationVisible.value = false;
  conditionVisible.value = false;
  delayVisible.value = false;
  routerVisible.value = false;
  loopVisible.value = false;
  infoVisible.value = false;
  if (activeTab.value !== 1) {
    activeTab.value = 1;
  }
  wizardDrawerVisible.value = true;
}

// "Analyze with Wizard" (simulate-step or run-flow process-log popup) must
// always land on an OPEN drawer — openWizardDrawer() toggles closed if already
// open, which would be wrong here.
function ensureWizardDrawerOpen() {
  if (!wizardDrawerVisible.value) {
    openWizardDrawer();
  }
}

// Shared by both triggers: the direct Run Flow path (this file's own
// <SimulateDialog>, closed via runFlowDialog) and the bubbled Simulate Step
// path (EditStep.vue/EditLoop.vue close their own simulateDialogVisible before
// re-emitting up — see @simulate-analyze-with-wizard below).
function handleAnalyzeWithWizard(activityIdToAnalyze: string) {
  if (!activityIdToAnalyze) return;
  // Same gate openWizardDrawer applies. Setting wizardAutoDebugContext is what starts an
  // analysis — WizardDrawer watches it and runs even while hidden — so without this the feature
  // flag could be off and a diagnosis would still be billed and executed.
  if (!aiWizardEnabled.value) return;
  runFlowDialog.value = false;
  ensureWizardDrawerOpen();
  // `status` is intentionally OMITTED (the field is optional). This trigger is SimulateDialog's
  // footer button, which shows for any run that has an activityId — including successful ones —
  // and EditStep's loadLastLogForStep() can set that id from an older Elasticsearch log, so the
  // run being analyzed is not necessarily the current one, let alone a failed one. Hardcoding
  // "FAILED" recorded a claim we cannot make. The flow's currentActivityStatus is no better: it
  // describes the latest run, not this activityId. Omitting is honest; ExecutionSummary.vue's
  // producer, which DOES know its run, passes the real status.
  wizardAutoDebugContext.value = {
    activityId: activityIdToAnalyze,
  };
}

function handleWizardAnalysisStarted() {
  showAlert(TYPE.INFO, t("TeggyAssistant.AnalyzingRun"));
}

function handleWizardAnalysisReady(payload?: {
  reused?: boolean;
  failed?: boolean;
}) {
  if (payload?.reused) return;
  if (payload?.failed) {
    showAlert(TYPE.ERROR, t("TeggyAssistant.AnalysisFailed"));
  } else {
    showAlert(TYPE.SUCCESS, t("TeggyAssistant.AnalysisReady"));
  }
}

function closeWizardDrawer() {
  wizardHistoryVisible.value = false;
  wizardDrawerVisible.value = false;
  wizardPreviewActive.value = false;
  wizardPreviewFlowSpec.value = null;
  wizardPreviewSubmitting.value = false;
}

async function handleHideTeggyPromo() {
  await updateSinglePreference("hideTeggyAssistantPromo", true);
}

function handleWizardApprovalStateChange(payload: {
  active: boolean;
  flowSpec: any;
  loading: boolean;
}) {
  wizardPreviewActive.value = payload.active;
  wizardPreviewFlowSpec.value = payload.flowSpec;
  wizardPreviewSubmitting.value = payload.active && payload.loading;
}

function handleWizardPreviewApprove() {
  if (wizardDrawerRef.value) wizardDrawerRef.value.handleApprove();
}

function handleWizardPreviewReject() {
  wizardPreviewActive.value = false;
  wizardPreviewFlowSpec.value = null;
  wizardPreviewSubmitting.value = false;
  if (wizardDrawerRef.value) wizardDrawerRef.value.handleReject();
}

function handleWizardPreviewFeedback(feedback: string) {
  wizardPreviewActive.value = false;
  wizardPreviewFlowSpec.value = null;
  wizardPreviewSubmitting.value = false;
  if (wizardDrawerRef.value) wizardDrawerRef.value.handleFeedback(feedback);
}

function handleWizardHistoryVisibilityChange(isVisible: boolean) {
  wizardHistoryVisible.value = isVisible;
}

async function handleWizardFlowCreated(createdFlowPayload?: any) {
  closeWizardDrawer();
  const createdFlowId = createdFlowPayload?.id;
  const createdFlowVersion = Number(createdFlowPayload?.version || 1);

  const { pathname } = window.location;
  let localePrefix = "";
  if (pathname.startsWith("/tr/")) {
    localePrefix = "/tr";
  } else if (pathname.startsWith("/en/")) {
    localePrefix = "/en";
  }

  if (!createdFlowId) {
    window.location.assign(`${localePrefix}/flows`);
    return;
  }

  window.location.assign(
    `${localePrefix}/flows/edit/${createdFlowId}/${createdFlowVersion}`
  );
}

function getSaveResultAlertKey(action: "created" | "updated") {
  const hasInvalidLoop = hasInvalidLoopBackConnection.value;

  if (action === "updated") {
    if (hasInvalidLoop) {
      return "Flow.FlowUpdatedInvalidLoop";
    }
    return "Flow.FlowUpdated";
  }

  if (hasInvalidLoop) {
    return "Flow.FlowCreatedInvalidLoop";
  }
  return "Flow.FlowCreated";
}

function showParallelThreadBudgetWarning(
  result: ParallelThreadBudgetResult
): void {
  if (!result.exceeded) return;

  showAlert(
    TYPE.WARNING,
    t("Flow.ParallelThreadBudgetExceeded", {
      totalThreadCount: result.totalThreadCount,
      threadBudget: result.threadBudget,
    })
  );
}

function showSaveResultAlert(
  action: "created" | "updated" | "published",
  threadBudget: ParallelThreadBudgetResult
): void {
  let message =
    action === "published"
      ? t("Flow.FlowPublished")
      : t(getSaveResultAlertKey(action));

  if (threadBudget.exceeded) {
    message += ` ${t("Flow.ParallelThreadBudgetExceededAfterSave", {
      totalThreadCount: threadBudget.totalThreadCount,
      threadBudget: threadBudget.threadBudget,
    })}`;
  }

  showAlert(
    (action !== "published" && hasInvalidLoopBackConnection.value) ||
      threadBudget.exceeded
      ? TYPE.WARNING
      : TYPE.SUCCESS,
    message
  );
}

function getCurrentFlowForParallelThreadBudget() {
  return {
    ...flow.value,
    steps: useAddPositionToStep(filterSteps(allStep.value), flowLines.value),
  };
}

onBeforeRouteLeave((to, from, next) => {
  if (to.query.skipUnsavedCheck === "true") {
    next();
    return;
  }
  if (!flowId.value || isVersionChanged.value) {
    isVersionChanged.value = false;
    next();
    return;
  }
  if (isAnyChange.value) {
    showConfirm(
      "warning",
      t("Flow.UnsavedChanges"),
      t("Flow.UnsavedChangesMessage")
    ).then((confirmed) => {
      if (confirmed) {
        isAnyChange.value = false;
        EventBus.isAnyChange = false;
        next();
      } else {
        next(false);
      }
    });
  } else {
    next();
  }
});

const backgroundColor = ref(
  getPreferenceValue("editFlowBackground")
    ? getPreferenceValue("editFlowBackground")
    : "#b5c0cd"
);
const predefinedColors = ref([
  "rgba(191, 181, 205, 1)",
  "#b5c0cd",
  "rgba(251, 193, 123, 0.64)",
  "rgba(144, 238, 144, 0.5)",
  "rgba(121, 166, 167, 0.63)",
  "rgba(146, 199, 251, 1)",
  "rgba(228, 172, 181, 1)",
  "rgba(238, 231, 191, 1)",
  "rgba(165, 249, 165, 0.5)",
  "rgba(115, 184, 186, 1)",
  "hsla(209, 100%, 56%, 0.73)",
  "rgba(190, 226, 227, 1)",
  "#c7158577",
]);
const tabList = ref([
  {
    tab: 2,
    name: "Versions",
    icon: "layer-group",
    tooltip: t("Flow.Versions"),
  },
  {
    tab: 3,
    name: "Activities",
    icon: "history",
    tooltip: t("Common.Activities"),
  },
]);

const pageOpen = ref(true);
const updatedFlow = ref();
const stepSimulating = ref(false);
const simulationDataRefreshKey = ref(0);
const popUpOpen = ref(false);
const outputList = ref([]);
const metaoutputList = ref([]);
const componentKey = ref(1);
const selectedStep = ref();
const selectedIndex = ref();
const isStepInRouter = ref(false);
const drawerVisible = ref(false);
const functionsVisible = ref(false);
const editStepKey = ref(0);
const loopDrawerKey = ref(0);
const routerDrawerKey = ref(0);
const flowDiagramRef = ref<any>(null);
const editLoopRef = ref<any>(null);
const flowName = ref("");
const nextRunTime = ref("");
const stepLoading = ref(false);
const responseLoading = ref(false);
const pageLoading = ref(false);
const outputLogs = ref([]);
const processLogs = ref();
const flowStatus = ref("");
const runFlowDialog = ref(false);
const activeTab = ref(1);
const statusClient = ref();
const infoVisible = ref(true);
const userVariableVisible = ref(false);
const conditionVisible = ref(false);
const delayVisible = ref(false);
const cronEditorVisible = ref(false);
const shortCutPressed = ref(false);
const isSubmitting = ref(false);
const contextMenuVisible = ref(false);
const contextMenuIndex = ref(-1);
const contextMenuStep = ref(null);
const routerVisible = ref(false);
const loopVisible = ref(false);
const updatedByName = ref("");
const createdAt = ref("");
const routerListIndex = ref("");
const editStepRef = ref();
const simulateInFlight = ref(false);
const isStepNameExceedingCharLimit = ref(false);
const { fitView } = useVueFlow();
const anyPrevDrawerOpen = ref(true);
const isAnyChange = ref(false);
const suppressFlowDiagramDirty = ref(false);
let flowDiagramDirtyReleaseTimer: ReturnType<typeof setTimeout> | null = null;
const isGenerating = ref(false);
const isRetrieving = ref(false);
const selectedReportFormat = ref("pdf");
const reportExists = ref(false);
const reportFlowVersion = ref<number | null>(null);
const isPdfReady = ref(false);
const isReportUpToDate = computed(
  () =>
    reportExists.value &&
    !isAnyChange.value &&
    reportFlowVersion.value !== null &&
    reportFlowVersion.value === flow.value?.version
);
const showAIReportSection = ref(false);
const startStepPosition = ref(null);
const charLimit = ref(200);
const clonedFlowCharLimit = ref(250);
const invalidEmail = ref("");
const dragScrollActive = ref(false);
const nameInputField = ref<HTMLElement>(null);
const activityId = ref("");
const userDefinedVariables = ref([]);
const udvErrors = ref([]);
const tree = ref([]);
const configurationVisible = ref(false);
const isSpecialCharEntered = ref(false);
const treeSource = ref("");
const filterText = ref("");
const treeRef = ref<InstanceType<typeof ElTree>>();
const hasFlowSettings = computed(
  () => Array.isArray(tree.value) && tree.value.length > 0
);
const pendingData = ref();
const newEdge = ref(null);
const updatedConfigurations = ref({});
const configResponseLoading = ref(false);
const expressionDrawer = ref(false);

watch(
  () => functionsVisible.value,
  (visible) => {
    if (!visible) {
      expressionDrawer.value = false;
    }
  }
);

const visibleOutputDailog = ref(false);
const systemVariables = ref([]);
const selectedOffset = ref<string | null>(null);
const selectedIdentifier = ref<string | null>(null);
const clonedStep = ref();
const createdByName = ref("");
const createdById = ref("");
const createdAtDate = ref("");
const expressions = ref([]);
const detailsSize = ref(
  getPreferenceValue("detailsBoxSize")
    ? getSizeByString(getPreferenceValue("detailsBoxSize"))
    : 0
);
const userVariableSize = ref(
  getPreferenceValue("userVariableBoxSize")
    ? getSizeByString(getPreferenceValue("userVariableBoxSize"))
    : 0
);
const editStepSize = ref(
  getPreferenceValue("editStepBoxSize")
    ? getSizeByString(getPreferenceValue("editStepBoxSize"))
    : 1
);
const filterSize = ref(
  getPreferenceValue("filterBoxSize")
    ? getSizeByString(getPreferenceValue("filterBoxSize"))
    : 0
);
const routerSize = ref(
  getPreferenceValue("conditionBoxSize")
    ? getSizeByString(getPreferenceValue("conditionBoxSize"))
    : 0
);
const loopSize = ref(
  getPreferenceValue("loopBoxSize")
    ? getSizeByString(getPreferenceValue("loopBoxSize"))
    : 1
);

const checkReportStatus = async () => {
  const activeFlowId = flow.value?.id;
  const activeFlowVersion = flow.value?.version;
  reportExists.value = false;
  reportFlowVersion.value = null;
  isPdfReady.value = false;
  showAIReportSection.value = false;

  const tenantId = authInfo.value?.tenantId;
  if (!tenantId || !(await isAIFlowReportingEnabledForTenant(tenantId))) {
    return;
  }

  if (
    flow.value?.id !== activeFlowId ||
    flow.value?.version !== activeFlowVersion
  ) {
    return;
  }

  showAIReportSection.value = true;
  if (activeFlowId) {
    const {
      exists,
      reportFlowVersion: fetchedVersion,
      pdfReady,
    } = await checkAIReportExists(activeFlowId);

    if (
      flow.value?.id !== activeFlowId ||
      flow.value?.version !== activeFlowVersion
    ) {
      return;
    }

    reportExists.value = exists;
    reportFlowVersion.value = fetchedVersion;
    isPdfReady.value = pdfReady;
  }
};

async function refreshReportStatus(targetFlowId: string) {
  const {
    exists,
    reportFlowVersion: fetchedVersion,
    pdfReady,
  } = await checkAIReportExists(targetFlowId);

  if (targetFlowId !== flow.value?.id) return;

  reportExists.value = exists;
  reportFlowVersion.value = fetchedVersion;
  isPdfReady.value = pdfReady;
}

async function listenForReportUpdates(
  requestId: string,
  isUpdate: boolean,
  targetFlowId: string
) {
  if (!requestId) return;

  const subscribeToTopic = () => {
    const statusTopic = WebsocketUrlProvider.ReportTopic();

    reportClient.subscribe(statusTopic, async (msg) => {
      try {
        if (!msg.body) return;

        const data = JSON.parse(msg.body);

        if (data.requestId !== requestId) {
          return;
        }

        if (data.status === "processing") {
          isGenerating.value = true;
        } else if (data.status === "completed") {
          isGenerating.value = false;
          const successMessageKey = isUpdate
            ? "Flow.ReportUpdatedSuccess"
            : "Flow.ReportGeneratedSuccess";
          showAlert(TYPE.SUCCESS, t(successMessageKey));
          await refreshReportStatus(targetFlowId);
        } else if (
          data.status === "pdf_ready" &&
          data.flowId === targetFlowId &&
          targetFlowId === flow.value?.id
        ) {
          isPdfReady.value = true;
        } else if (data.status === "failed") {
          isGenerating.value = false;
          showAlert(
            TYPE.ERROR,
            t("Flow.ReportStatusError", {
              message: data.message || t("Flow.UnknownError"),
            })
          );
        }
      } catch (error) {
        console.error("Error parsing WebSocket message:", error);
      }
    });
  };

  if (!reportClient || !reportClient.connected) {
    try {
      const stompClient = await connectWebsocket();
      reportClient = stompClient;
      reportClient.debug = (f) => f;

      const headers = {
        host: "/",
      };

      reportClient.connect(
        headers,
        () => {
          subscribeToTopic();
        },
        () => {
          isGenerating.value = false;
          showAlert(TYPE.ERROR, t("Flow.WebSocketConnectionFailed"));
        }
      );
    } catch (e) {
      isGenerating.value = false;
      showAlert(TYPE.ERROR, t("Flow.WebSocketConnectionError"));
    }
  } else {
    subscribeToTopic();
  }
}

async function generateOrUpdateReport(isUpdate: boolean) {
  if (!flow.value || !flow.value.id) {
    showAlert(TYPE.WARNING, t("Flow.FlowMustBeSavedBeforeReport"));
    return;
  }

  const targetFlowId = flow.value.id;
  isGenerating.value = true;
  try {
    const flowDataToSend = cloneDeep(flow.value);
    flowDataToSend.flowLines = cloneDeep(
      flow.value?.flowLines ?? flowLines.value
    );
    flowDataToSend.steps = useAddPositionToStep(
      filterSteps(allStep.value),
      flowDataToSend.flowLines
    );
    overrideIxForBackend(flowDataToSend.steps);
    await addSourceAndTarget(flowDataToSend);

    let response;

    if (isUpdate) {
      response = await updateAIReport(targetFlowId, flowDataToSend);
    } else {
      response = await generateAIReport(flowDataToSend);
    }

    if (response?.apiError !== undefined) {
      const code = response.apiError;
      let msg: string;
      if (code === 401) {
        msg = t("Flow.SessionExpired");
      } else if (code === 403) {
        msg = t("Flow.PermissionDenied");
      } else if (code === 500) {
        msg = t("Flow.ServerError");
      } else if (isUpdate) {
        msg = t("Flow.ReportUpdateFailed");
      } else {
        msg = t("Flow.ReportGenerateFailed");
      }
      showAlert(TYPE.ERROR, msg);
      isGenerating.value = false;
      return;
    }

    if (response && response.requestId) {
      listenForReportUpdates(response.requestId, isUpdate, targetFlowId);
    } else {
      isGenerating.value = false;
      if (response) {
        const successMessageKey = isUpdate
          ? "Flow.ReportUpdatedSuccess"
          : "Flow.ReportGeneratedSuccess";
        showAlert(TYPE.SUCCESS, t(successMessageKey));
        await refreshReportStatus(targetFlowId);
      }
    }
  } catch (error) {
    const errorMessageKey = isUpdate
      ? "Flow.ReportUpdateError"
      : "Flow.ReportGenerationError";
    showAlert(TYPE.ERROR, t(errorMessageKey));
    isGenerating.value = false;
  }
}

async function onGenerateReport() {
  await generateOrUpdateReport(false);
}

async function onUpdateReport() {
  await generateOrUpdateReport(true);
}

async function onRetrieveReport() {
  if (!flowId.value) {
    showAlert(TYPE.ERROR, t("Flow.FlowIdNotFound"));
    return;
  }

  if (selectedReportFormat.value === "pdf" && !isPdfReady.value) {
    showAlert(TYPE.WARNING, t("Flow.PdfStillRendering"));
    return;
  }

  isRetrieving.value = true;
  try {
    const success = await getAIReport(flowId.value, selectedReportFormat.value);
    if (success) {
      showAlert(TYPE.SUCCESS, t("Flow.ReportDownloadedSuccess"));
    } else {
      showAlert(TYPE.ERROR, t("Flow.ReportDownloadFailed"));
    }
  } catch (error) {
    console.error(error);
    showAlert(TYPE.ERROR, t("Flow.ReportDownloadError"));
  } finally {
    isRetrieving.value = false;
  }
}

watch(
  () => EventBus.isAnyChange,
  (newVal) => {
    isAnyChange.value = newVal;
  }
);

const isLoopPanelMounted = computed(
  () =>
    (selectedStep.value?.type === "LOOP" ||
      selectedStep.value?.type === "LOOP_END") &&
    loopVisible.value &&
    !!editLoopRef.value
);

const isEditStepPanelMounted = computed(
  () =>
    drawerVisible.value &&
    !conditionVisible.value &&
    !infoVisible.value &&
    !!editStepRef.value
);

const showSimulateControls = computed(
  () =>
    (isLoopPanelMounted.value || isEditStepPanelMounted.value) &&
    !!selectedStep.value &&
    isPersistedFlowStep(selectedStep.value) &&
    !!flow.value.latest &&
    selectedStep.value.type !== "ROUTER"
);

const showSimulateRegular = computed(
  () => showSimulateControls.value && !selectedStep.value?.parentId
);

const showSimulateRouterChild = computed(
  () => showSimulateControls.value && !!selectedStep.value?.parentId
);

function isPersistedFlowStep(step: any) {
  return (
    typeof step?.id === "string" &&
    !step.id.includes("new") &&
    (typeof step?.createdAt === "string" || typeof step?.updatedAt === "string")
  );
}

const editFlowContent = ref<HTMLElement>(null);
let client;
let reportClient;
const showingStepOutputData = reactive({ output: undefined, displayNumber: 0 });
const { getStepDisplayNumber } = useStepDisplay();
const areStepsValid = computed(() => checkStepsValid());
const isDescriptionNearLimit = computed(
  () => flow.value?.description?.length > currentCharLimit.value
);
const flowId = computed(() => currentRoute.value.params.id as string);
const version = computed(() => currentRoute.value.params.version as string);
const taggyScreenKey = computed(() =>
  flowId.value ? `${flowId.value}:${version.value || "current"}` : "create-flow"
);

const isTeggyPromoHidden = computed(() =>
  Boolean(getPreferenceValue("hideTeggyAssistantPromo"))
);

const isTaggySurfaceVisible = computed(
  () => activeTab.value === 1 && !pageLoading.value
);
const currentWizardFlowSnapshot = computed(() => {
  if (!flow.value || !wizardDrawerVisible.value) {
    return null;
  }

  const currentFlowLines = flow.value?.flowLines ?? flowLines.value;

  return buildWizardFlowSnapshot({
    flow: flow.value,
    steps: useAddPositionToStep(cloneDeep(steps.value), currentFlowLines),
    flowLines: cloneDeep(currentFlowLines),
  });
});
const flowRunning = computed(() => isRunning(flowStatus.value));
const canStopFlow = computed(() => hasPermission("FLOWS.LIST.STOP"));
const isNameNearLimit = computed(() => {
  if (flow.value?.name?.includes("CLONE")) {
    return flow.value?.name?.length > clonedFlowCharLimit.value;
  }
  return flow.value?.name?.length > charLimit.value;
});
const isResizing = ref(false);
const functionDrawerReservePx = computed<number>(() => {
  if (!functionsVisible.value) return 0;
  return expressionDrawer.value
    ? FUNCTION_EXPRESSION_DRAWER_WIDTH
    : FUNCTION_DRAWER_WIDTH;
});
const currentEditStepWidthPx = computed(() =>
  Math.round(editStepWidthPx.value + functionDrawerReservePx.value)
);
const currentConditionWidthPx = computed(() =>
  Math.round(conditionWidthPx.value + functionDrawerReservePx.value)
);
const currentRouterWidthPx = computed(() =>
  Math.round(routerWidthPx.value + functionDrawerReservePx.value)
);
const minEditStepWidth = computed<number>(
  () => EDIT_STEP_BASE_MIN_WIDTH + functionDrawerReservePx.value
);
const minConditionWidth = computed<number>(
  () => CONDITION_BASE_MIN_WIDTH + functionDrawerReservePx.value
);
const minRouterWidth = computed<number>(
  () => ROUTER_BASE_MIN_WIDTH + functionDrawerReservePx.value
);
const maxEditStepWidth = computed<number>(() =>
  functionsVisible.value ? 1350 : 1850
);
function getDrawerBaseMaxWidth(minBaseWidth: number) {
  return Math.max(
    minBaseWidth,
    Math.min(
      maxEditStepWidth.value,
      MAX_DRAWER_RENDER_WIDTH - functionDrawerReservePx.value
    )
  );
}
function clampDrawerBaseWidth(width: number, minBaseWidth: number) {
  return clamp(width, minBaseWidth, getDrawerBaseMaxWidth(minBaseWidth));
}
function getWizardBaseMaxWidth() {
  return Math.max(
    WIZARD_BASE_MIN_WIDTH,
    MAX_DRAWER_RENDER_WIDTH -
      (wizardHistoryVisible.value ? WIZARD_HISTORY_DRAWER_WIDTH : 0)
  );
}
function clampWizardBaseWidth(width: number) {
  return clamp(width, WIZARD_BASE_MIN_WIDTH, getWizardBaseMaxWidth());
}
const editStepWidthPx = ref<number>(
  clampDrawerBaseWidth(
    getNumberPref("editStepBoxWidthPx", EDIT_STEP_BASE_MIN_WIDTH),
    EDIT_STEP_BASE_MIN_WIDTH
  )
);
const conditionWidthPx = ref<number>(
  clampDrawerBaseWidth(
    getNumberPref("conditionBoxWidthPx", CONDITION_BASE_MIN_WIDTH),
    CONDITION_BASE_MIN_WIDTH
  )
);
const routerWidthPx = ref<number>(
  clampDrawerBaseWidth(
    getNumberPref("routerBoxWidthPx", ROUTER_BASE_MIN_WIDTH),
    ROUTER_BASE_MIN_WIDTH
  )
);
const wizardWidthPx = ref<number>(
  clampWizardBaseWidth(getNumberPref("wizardBoxWidthPx", WIZARD_BASE_MIN_WIDTH))
);

const currentWizardWidthPx = computed(() =>
  Math.round(
    clampWizardBaseWidth(wizardWidthPx.value) +
      (wizardHistoryVisible.value ? WIZARD_HISTORY_DRAWER_WIDTH : 0)
  )
);
const minWizardWidth = computed<number>(
  () =>
    WIZARD_BASE_MIN_WIDTH +
    (wizardHistoryVisible.value ? WIZARD_HISTORY_DRAWER_WIDTH : 0)
);

const editStepBoxRef = ref<HTMLElement | null>(null);
const infoBoxRef = ref<HTMLElement | null>(null);
const conditionBoxRef = ref<HTMLElement | null>(null);
const routerBoxRef = ref<HTMLElement | null>(null);
const userVarsBoxRef = ref<HTMLElement | null>(null);
const wizardBoxRef = ref<HTMLElement | null>(null);

const currentCharLimit = computed(() => {
  if (flow.value && flow.value.name) {
    return flow.value.name.includes("CLONE")
      ? clonedFlowCharLimit.value
      : charLimit.value;
  }
  return charLimit.value;
});

const anyDrawerOpen = computed(
  () =>
    infoVisible.value ||
    routerVisible.value ||
    conditionVisible.value ||
    delayVisible.value ||
    loopVisible.value
);
watch(filterText, (val) => {
  treeRef.value.filter(val);
});
watch(hasFlowSettings, (available) => {
  if (!available && configurationVisible.value) {
    configurationVisible.value = false;
  }
});

function recomputeOutputLists() {
  const currentFlowLines = flow.value?.flowLines ?? flowLines.value;
  const positioned = useAddPositionToStep(steps.value, currentFlowLines);
  const nextOutputList = getOutputListForAllStep(positioned, {
    useStableIndex: true,
    skipPositioning: true,
  });
  const nextMetaoutputList = getMetaoutputListForAllStep(positioned, {
    useStableIndex: true,
    skipPositioning: true,
  });
  outputList.value = sortOutputItemsByGraphOrder(
    nextOutputList,
    positioned,
    currentFlowLines
  );
  metaoutputList.value = sortOutputItemsByGraphOrder(
    nextMetaoutputList,
    positioned,
    currentFlowLines
  );
}

const debouncedRecomputeOutputLists = debounce(recomputeOutputLists, 250);

watch(
  () => steps.value,
  () => {
    debouncedRecomputeOutputLists();
  },
  { deep: true, immediate: true }
);

watch(
  () => backgroundColor.value,
  () => {
    updateSinglePreference("editFlowBackground", backgroundColor.value);
  }
);

watch(anyDrawerOpen, (newVal) => {
  if (newVal && !anyPrevDrawerOpen.value) {
    anyPrevDrawerOpen.value = true;
  }
});

const disableSimulateButton = computed(() => {
  if (!selectedStep.value) return true;
  return stepSimulating.value || !isPersistedFlowStep(selectedStep.value);
});

async function simulateSelectedStep(
  bypassConditions = false,
  opts: { silent?: boolean; reason?: string } = {}
) {
  if (simulateInFlight.value) return;
  if (!selectedStep.value) return;

  simulateInFlight.value = true;
  let savedBeforeSimulation = false;
  try {
    if (isAnyChange.value) {
      savedBeforeSimulation = true;
      await onFlowSubmit();
      if (isAnyChange.value) return;
      await nextTick();
    }

    if (!selectedStep.value) return;

    const parallelThreadBudget = await evaluateParallelThreadBudget(
      getCurrentFlowForParallelThreadBudget()
    );
    if (parallelThreadBudget.exceeded) {
      showParallelThreadBudgetWarning(parallelThreadBudget);
      return;
    }

    const isLoop =
      selectedStep.value.type === "LOOP" ||
      selectedStep.value.type === "LOOP_END";
    const simulationTarget = await getSimulationTarget(isLoop);

    if (!simulationTarget) {
      console.warn(
        isLoop ? "editLoopRef is not ready yet" : "editStepRef is not ready yet"
      );
      return;
    }

    if (savedBeforeSimulation && !isLoop && simulationTarget.resetStepChanges) {
      simulationTarget.resetStepChanges();
    }

    if (isLoop) {
      await simulationTarget.simulate(bypassConditions, opts);
      return;
    }

    await simulationTarget.simulate(bypassConditions, opts);
  } finally {
    simulateInFlight.value = false;
  }
}

async function onSaveAfterSpec({ autoValidate }: { autoValidate: boolean }) {
  try {
    await onFlowSubmit();
  } catch {
    showAlert(TYPE.WARNING, t("Flow.JoltSaveFailedAfterGeneration"));
    return;
  }

  if (isAnyChange.value) {
    showAlert(TYPE.WARNING, t("Flow.JoltSaveFailedAfterGeneration"));
    return;
  }

  showAlert(TYPE.SUCCESS, t("Flow.JoltSavedAfterGeneration"));

  if (autoValidate) {
    try {
      await simulateSelectedStep(false, {
        silent: true,
        reason: "validate-after-spec",
      });
    } catch (err) {
      // Save already succeeded — a validation error must not be reported as a
      // save failure. EditStep surfaces validation failures via its own toast.
      console.error("Post-generation validation failed:", err);
    }
  }
}

function waitForSimulationTargetRender() {
  return new Promise<void>((resolve) => {
    setTimeout(resolve, 0);
  });
}

async function getSimulationTarget(isLoop: boolean) {
  for (let attempt = 0; attempt < 5; attempt++) {
    await nextTick();
    const target = isLoop ? editLoopRef.value : editStepRef.value;
    if (selectedStep.value && target?.simulate) {
      return target;
    }
    await waitForSimulationTargetRender();
  }

  return null;
}

const filterNode = (value, data) => {
  if (!value) return true;
  const labelMatch = data.label.toLowerCase().includes(value.toLowerCase());
  const valueMatch = data.inputValue
    .toLowerCase()
    .includes(value.toLowerCase());
  return labelMatch || valueMatch;
};

const defaultProps = {
  children: "children",
  label: "label",
};

async function resumeSkillStatus() {
  const currentFlowId = flowId.value;
  const currentFlowVersion =
    flow.value?.version != null ? Number(flow.value.version) : null;
  if (
    !currentFlowId ||
    currentFlowVersion == null ||
    Number.isNaN(currentFlowVersion)
  ) {
    return;
  }
  if (skillPollInterval !== null) {
    clearInterval(skillPollInterval);
    skillPollInterval = null;
  }
  const pending = getPersistedSkillGenJob(currentFlowId, currentFlowVersion);
  const flowVersionForStatus = pending?.flowVersion ?? currentFlowVersion;
  if (flowVersionForStatus !== currentFlowVersion) return;
  const isActiveFlowVersion = () =>
    flowId.value === currentFlowId &&
    flow.value?.version != null &&
    Number(flow.value.version) === currentFlowVersion;
  let trackedJobId = pending?.jobId;
  if (!pending) {
    const status = await getFlowSkillStatus(
      currentFlowId,
      flowVersionForStatus
    );
    if (!isActiveFlowVersion()) return;
    skillExists.value = status.exists;
    skillFlowVersion.value = status.flowVersion;
    isGeneratingSkill.value = status.status === "processing";
    trackedJobId = status?.jobId || undefined;
    if (status?.status !== "processing") return;
  }
  // Check if the backend already finished while the user was away
  const status = await getFlowSkillStatus(
    currentFlowId,
    flowVersionForStatus,
    trackedJobId
  );
  if (!isActiveFlowVersion()) return;
  trackedJobId = trackedJobId || status.jobId || undefined;
  if (status.status === "error") {
    isGeneratingSkill.value = false;
    clearSkillGenJob(currentFlowId, flowVersionForStatus);
    showAlert(TYPE.ERROR, t("Flow.SkillGenerationFailed"));
    return;
  }
  if (
    status.status === "completed" ||
    (!trackedJobId && status.exists && status.status !== "processing")
  ) {
    skillExists.value = true;
    skillFlowVersion.value = status.flowVersion ?? flowVersionForStatus;
    isGeneratingSkill.value = false;
    clearSkillGenJob(currentFlowId, flowVersionForStatus);
    return;
  }
  // Still in progress — show generating and poll Qdrant every 15 s
  isGeneratingSkill.value = true;
  const pollStart = Date.now();
  let pollInterval: ReturnType<typeof setInterval> | null = null;
  const stopThisPoller = () => {
    if (pollInterval === null) return;
    clearInterval(pollInterval);
    if (skillPollInterval === pollInterval) {
      skillPollInterval = null;
    }
    pollInterval = null;
  };
  pollInterval = setInterval(async () => {
    if (!isActiveFlowVersion()) {
      stopThisPoller();
      return;
    }
    if (Date.now() - pollStart > skillGenPollTimeoutMs) {
      stopThisPoller();
      clearSkillGenJob(currentFlowId, flowVersionForStatus);
      isGeneratingSkill.value = false;
      showAlert(TYPE.ERROR, t("Flow.SkillGenerationFailed"));
      return;
    }
    try {
      const s = await getFlowSkillStatus(
        currentFlowId,
        flowVersionForStatus,
        trackedJobId
      );
      if (!isActiveFlowVersion()) {
        stopThisPoller();
        return;
      }
      if (s.status === "error") {
        stopThisPoller();
        clearSkillGenJob(currentFlowId, flowVersionForStatus);
        isGeneratingSkill.value = false;
        showAlert(TYPE.ERROR, t("Flow.SkillGenerationFailed"));
      } else if (
        s.status === "completed" ||
        (!trackedJobId && s.exists && s.status !== "processing")
      ) {
        stopThisPoller();
        clearSkillGenJob(currentFlowId, flowVersionForStatus);
        skillExists.value = true;
        skillFlowVersion.value = s.flowVersion ?? flowVersionForStatus;
        isGeneratingSkill.value = false;
        showAlert(TYPE.SUCCESS, t("Flow.SkillGeneratedSuccess"));
      }
    } catch {
      // Keep polling on transient status failures.
    }
  }, skillGenPollIntervalMs);
  skillPollInterval = pollInterval;
}

async function waitForSkillJobCompletion(jobId: string): Promise<void> {
  return new Promise((resolve, reject) => {
    connectWebsocket()
      .then((stompClient) => {
        skillClient = stompClient;
        stompClient.connect(
          { host: "/" },
          () => {
            const sub = stompClient.subscribe("/wizard", (msg: any) => {
              const data = JSON.parse(msg.body);
              if (data.sessionId !== jobId) return;
              if (data.status === "completed") {
                sub.unsubscribe();
                stompClient.disconnect();
                skillClient = undefined;
                resolve();
              } else if (data.status === "error") {
                sub.unsubscribe();
                stompClient.disconnect();
                skillClient = undefined;
                reject(new Error(data.message));
              }
            });
          },
          (_error) => {
            skillClient = undefined;
            reject(new Error("WebSocket connection failed"));
          }
        );
      })
      .catch(reject);
  });
}

async function onGenerateSkill() {
  if (isGeneratingSkill.value) return;
  if (!flowId.value || flow.value?.version == null) {
    showAlert(TYPE.WARNING, t("Flow.FlowNotSaved"));
    return;
  }
  if (!canGenerateSkill.value) {
    showAlert(TYPE.WARNING, t("Flow.UnsavedChanges"));
    return;
  }
  const generationFlowVersion = Number(flow.value.version);
  isGeneratingSkill.value = true;
  let keepGenerating = false;
  let jobId: string | undefined;
  try {
    const rawFlow = await getFlow(flowId.value, String(flow.value.version));
    if (!rawFlow) {
      throw new Error("Failed to load the saved flow for skill generation");
    }
    const { jobId: generatedJobId } = await generateFlowSkill(
      { result: [rawFlow] },
      flowId.value,
      generationFlowVersion,
      skillGenerationEnabled.value
    );
    jobId = generatedJobId;
    persistSkillGenJob(flowId.value, generatedJobId, generationFlowVersion);
    resumeSkillStatus();
    await waitForSkillJobCompletion(generatedJobId);
    if (skillPollInterval !== null) {
      clearInterval(skillPollInterval);
      skillPollInterval = null;
    }
    if (isGeneratingSkill.value || !skillExists.value) {
      skillExists.value = true;
      skillFlowVersion.value = generationFlowVersion;
      clearSkillGenJob(flowId.value, generationFlowVersion);
      showAlert(TYPE.SUCCESS, t("Flow.SkillGeneratedSuccess"));
    }
  } catch (error) {
    const status =
      flowId.value && jobId
        ? await getFlowSkillStatus(
            flowId.value,
            flow.value?.version != null ? Number(flow.value.version) : null,
            jobId
          )
        : null;
    keepGenerating = status?.status === "processing";
    if (status?.status === "error")
      clearSkillGenJob(flowId.value, generationFlowVersion);
    if (keepGenerating) resumeSkillStatus();
    if (!keepGenerating) {
      showAlert(
        TYPE.ERROR,
        error instanceof Error && error.message
          ? error.message
          : t("Flow.SkillGenerationFailed")
      );
    }
  } finally {
    if (!keepGenerating) isGeneratingSkill.value = false;
  }
}

onUnmounted(() => {
  pageOpen.value = false;
  clearFlowDiagramDirtyReleaseTimers();
  debouncedRecomputeOutputLists.cancel();
  if (statusClient.value) {
    statusClient.value.disconnect();
    statusClient.value = undefined;
  }
});

onMounted(async () => {
  pageLoading.value = true;

  const tenantId = authInfo.value?.tenantId;
  if (tenantId) {
    aiWizardEnabled.value = await isAIWizardEnabledForTenant(tenantId);
    aiSkillGeneratorEnabled.value = await isAISkillGeneratorEnabledForTenant(
      tenantId
    );
  }

  const [pollIntervalRaw, pollTimeoutRaw] = await Promise.all([
    getProperty("ai.skill-generator.poll-interval-ms"),
    getProperty("ai.skill-generator.poll-timeout-ms"),
  ]);
  const parsedInterval = Number(pollIntervalRaw);
  const parsedTimeout = Number(pollTimeoutRaw);
  if (pollIntervalRaw && !Number.isNaN(parsedInterval) && parsedInterval > 0)
    skillGenPollIntervalMs = parsedInterval;
  if (pollTimeoutRaw && !Number.isNaN(parsedTimeout) && parsedTimeout > 0)
    skillGenPollTimeoutMs = parsedTimeout;

  const shouldRestoreWizard = consumeWizardReopenAfterRefresh();

  if (flowId.value && version.value) {
    initializeWizardSessionScope(
      `flow:${flowId.value}:${version.value}`,
      shouldRestoreWizard
    );
  } else {
    if (!shouldRestoreWizard) {
      resetPersistedWizardSession();
    }
    initializeWizardSessionScope("create-flow", shouldRestoreWizard);
  }

  try {
    connections.value = await getConnections();
    connectors.value = await getOrganizationsConnectorList();
    if (nameInputField.value) {
      nameInputField.value.focus();
    }
    // If editing flow instead of creating
    if (flowId.value && version.value) {
      await getSelectedFlow();
      isAnyChange.value = false;
      EventBus.isAnyChange = false;
      checkReportStatus();
      if (isMigrated.value) {
        await nextTick();
        organizeSteps(allStep.value, true);
        setTimeout(async () => {
          await onFlowSubmit();
          router.replace({
            name: "editFlowsRouteNew",
            params: { id: flowId.value, version: version.value },
          });
        }, 500);
      }
    } else {
      const step = {
        id: `new-step-${uuidv4()}`,
        uniqueId: uniqueId(),
        origId: uuidv4(),
      };
      assignStepNumber(step, flow.value);
      const positionedInitialSteps = useAddPositionToStep([step]);
      organizeSteps(positionedInitialSteps, true);
    }

    window.addEventListener("keydown", saveShortCut);
    window.addEventListener("keyup", () => {
      shortCutPressed.value = false;
    });
  } catch (e) {
    console.log("has error when page was loading", e);
  }
  await getSysVariables();
  await getExpressions();
  await fetchExecutionList();
  await getConfigurationVariables();
  pageLoading.value = false;
  if (suppressFlowDiagramDirty.value) {
    releaseFlowDiagramInitialSyncAfterFlush();
  }
  if (shouldRestoreWizard) {
    await nextTick();
    openWizardDrawer();
  }
});

onBeforeUnmount(() => {
  window.removeEventListener("keydown", saveShortCut);
  if (client) {
    client.disconnect();
  }
});

const isMigrated = computed(() => currentRoute?.query?.migrated === "true");

async function submitConfigChanges() {
  const updatePromises = Object.values(updatedConfigurations.value).map(
    (data) => updateConfigurationFrameworkValue(data, flow.value.id)
  );
  await Promise.all(updatePromises);
  updatedConfigurations.value = {};
}
async function getConfigurationVariables() {
  if (flowId.value) {
    try {
      const response = await getConfigurationFramework(flowId.value);
      if (response && Array.isArray(response)) {
        const sortByKey = (node) => {
          if (node.children && node.children.length > 0) {
            node.children.sort((a, b) => a.key.localeCompare(b.key));
            node.children.forEach(sortByKey);
          }
        };
        response.forEach(sortByKey);
        tree.value = mapApiDataToTree(response);
        treeSource.value = "config";
      } else if (response && response.code === "404") {
        await fetchExecutionProperties();
      }
    } catch (error) {
      console.error("Error fetching configuration variables:", error);
    }
  }
}
async function fetchExecutionProperties() {
  const executionProperties = await getExecutionProperties();
  if (executionProperties) {
    const treeItem = {
      id: flowId.value,
      label: executionProperties.key,
      level: "FLOW",
      type: "STRING",
      inputValue: executionProperties.defaultValue,
      lastSavedValue: executionProperties.defaultValue,
      description: executionProperties.description,
      children: [],
    };
    pendingData.value = {
      deleted: false,
      key: executionProperties.key,
      level: "FLOW",
      value: executionProperties.defaultValue,
      description: executionProperties.description,
      type: "STRING",
      children: [],
      ownerId: flowId.value,
      enumerationValues: executionProperties.enumerationValues,
    };
    if (executionProperties.enumerationValues.length > 0) {
      treeItem.enumerationValues = executionProperties.enumerationValues;
    }
    tree.value = [treeItem];
    treeSource.value = "exec";
  }
}
function mapApiDataToTree(apiData) {
  return apiData.map((item) => ({
    id: item.ownerId,
    label: item.key,
    description: item.description || "",
    level: item.level,
    type: item.type,
    inputValue: item.value || "",
    lastSavedValue: item.value || "",
    enumerationValues: item.enumerationValues || [],
    children: item.children ? mapApiDataToTree(item.children) : [],
  }));
}
function showConfiguration() {
  if (!hasFlowSettings.value) {
    configurationVisible.value = false;
    return;
  }
  if (configurationVisible.value) {
    configurationVisible.value = false;
  } else {
    closeDrawer();
    wizardDrawerVisible.value = false;
    conditionVisible.value = false;
    delayVisible.value = false;
    routerVisible.value = false;
    infoVisible.value = false;
    userVariableVisible.value = false;
    if (activeTab.value !== 1) {
      activeTab.value = 1;
    }
    configurationVisible.value = true;
  }
}

function addStepEdge(edge: { source: string; target: string }) {
  newEdge.value = edge;
}

function removeStep(index, step) {
  if (selectedStep.value?.id === step.id) {
    closeDrawer();
  }
  onRemoveStep(steps.value, step);
  steps.value = [...steps.value];
  allStep.value = cloneDeep(steps.value);
  organizeOutputData(steps.value);
  updateStep(true);
}

function onRemoveStep(list, targetStep) {
  list.forEach((item, index) => {
    if (item.id === targetStep.id) {
      list.splice(index, 1);
    }
    if (item.type) {
      item.routes.forEach((route) => onRemoveStep(route.steps, targetStep));
    }
  });
}

function formatUdv() {
  const formattedObj = {};

  userDefinedVariables.value.forEach((item) => {
    if (item.value.itemKey && item.value.itemKey.trim() !== "") {
      let value = "";
      try {
        value = JSON.parse(item.value.itemValue);
      } catch (error) {
        value = item.value.itemValue;
      }
      formattedObj[item.value.itemKey] = value;
    }
  });

  return formattedObj;
}

async function getExpressions() {
  await getExpressionDetails().then((response) => {
    expressions.value = response;
  });
}

function parseUdv(userDefVar) {
  if (userDefVar === undefined || userDefVar === null) return;
  const userDefVarArr = Object.entries(userDefVar);
  userDefinedVariables.value = [];

  userDefVarArr.forEach(([key, value]) => {
    const parsedValue =
      typeof value === "string" ? value : JSON.stringify(value);
    const itemObj = ref({
      itemKey: key,
      itemValue: parsedValue,
    });
    userDefinedVariables.value.push(itemObj);
  });
}

function changeDrawerSize() {
  if (drawerVisible.value) {
    if (editStepSize.value === 2) {
      closeDrawer();
      editStepSize.value = 0;
    } else {
      editStepSize.value++;
    }
    updateSinglePreference(
      "editStepBoxSize",
      getSizeByValue(editStepSize.value)
    );
  } else if (infoVisible.value) {
    if (detailsSize.value === 2) {
      showInfo();
      detailsSize.value = 0;
    } else {
      detailsSize.value++;
    }
    updateSinglePreference("detailsBoxSize", getSizeByValue(detailsSize.value));
  } else if (conditionVisible.value) {
    if (filterSize.value === 2) {
      showCondition();
      filterSize.value = 0;
    } else {
      filterSize.value++;
    }
    updateSinglePreference("filterBoxSize", getSizeByValue(filterSize.value));
  } else if (routerVisible.value) {
    if (routerSize.value === 2) {
      closeRouterSettings();
      routerSize.value = 0;
    } else {
      routerSize.value++;
    }
    updateSinglePreference(
      "conditionBoxSize",
      getSizeByValue(routerSize.value)
    );
  } else if (loopVisible.value) {
    if (loopSize.value === 2) {
      closeLoopSettings();
      loopSize.value = 0;
    } else {
      loopSize.value++;
    }
    updateSinglePreference("loopBoxSize", getSizeByValue(loopSize.value));
  } else if (userVariableVisible.value) {
    if (userVariableSize.value === 2) {
      showUserVariables();
      userVariableSize.value = 0;
    } else {
      userVariableSize.value++;
    }
    updateSinglePreference(
      "userVariableBoxSize",
      getSizeByValue(userVariableSize.value)
    );
  }
}
const executionList = ref([]);
const defaultExecution = ref([]);
const selectedExecution = ref(null);
const tenantDefaultExecution = ref([]);

async function fetchExecutionList() {
  try {
    const executions = await getOrganizationsExecutions(
      authInfo.value.organizationId
    );
    tenantDefaultExecution.value = await getTenantDefault(
      authInfo.value.tenantId
    );
    const organizationDefaultExecution = await getOrganizationDefault(
      authInfo.value.organizationId
    );
    if (organizationDefaultExecution) {
      defaultExecution.value = organizationDefaultExecution[0]?.execution?.id;
    } else if (tenantDefaultExecution.value) {
      defaultExecution.value = tenantDefaultExecution.value[0]?.execution?.id;
    }
    executionList.value = executions || [];
    const flowExecutionExists =
      executions?.some((exe) => {
        const exeId = exe?.id ?? null;
        const flowExecutionId = flow?.value?.execution?.id ?? null;
        return (
          exeId !== null &&
          flowExecutionId !== null &&
          exeId === flowExecutionId
        );
      }) ?? false;
    if (!flowExecutionExists && defaultExecution.value) {
      selectedExecution.value = defaultExecution.value;
      handleExecutionChange(defaultExecution.value);
    }
  } catch (error) {
    console.error("Failed to fetch execution list:", error);
    showAlert(TYPE.ERROR, t("Common.ExecutionFetchError"));
  }
}
function getLogoSrc(selectedId) {
  const selected = executionList.value.find((item) => item.id === selectedId);
  if (selected) {
    const typeFormatted = selected.type;
    return `${ASSETS_BASE_URL}/${typeFormatted}${getResolution(false)}.png`;
  }
  return `${ASSETS_BASE_URL}/default-logo.png`;
}

function handleExecutionChange(selectedExecutionId) {
  const selectedExecutionObj = executionList.value.find(
    (execution) => execution.id === selectedExecutionId
  );
  if (selectedExecutionObj) {
    flow.value.execution = selectedExecutionObj;
  }
}

watch(
  () => flow.value.execution,
  (newExec) => {
    if (newExec) {
      selectedExecution.value = flow.value.execution.id || null;
    }
  },
  { immediate: true }
);

function getUdvErrorKey(event) {
  if (event?.stepNumber) return `stepNumber:${event.stepNumber}`;
  if (event?.origId) return `origId:${event.origId}`;
  if (event?.id) return `id:${event.id}`;
  if (event?.uniqueId !== undefined && event?.uniqueId !== null) {
    return `uniqueId:${event.uniqueId}`;
  }
  return `index:${event?.index}`;
}

function getUdvErrorStepNumber(err) {
  let positionalIndex = 0;
  if (typeof err?.index === "number") {
    positionalIndex = err.index;
  } else if (typeof err?.ix === "number") {
    positionalIndex = err.ix;
  }
  return getStepDisplayNumber(positionalIndex, err?.stepNumber);
}

function handleUdvError(event) {
  const key = getUdvErrorKey(event);
  const nextEvent = { ...event, key };
  const index = udvErrors.value.findIndex((err) => err.key === key);
  if (index !== -1) {
    udvErrors.value[index] = nextEvent;
  } else {
    udvErrors.value.push(nextEvent);
  }
}
function addUserDefinedVariables() {
  const item = ref({ itemKey: "", itemValue: "" });
  userDefinedVariables.value.push(item);
  isAnyChange.value = true;
  EventBus.isAnyChange = true;
}
function preventLetters(event) {
  const allowedChars = /^[a-zA-Z0-9]*$/;
  if (
    !allowedChars.test(event.key) &&
    !["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(event.key)
  ) {
    event.preventDefault();
  }
}
function updateUserDefinedVariables(e, key, index) {
  let val = e;
  const allowedChars = /^[a-zA-Z0-9]*$/;
  if (
    key === "itemKey" &&
    !allowedChars.test(e) &&
    !["Backspace", "Delete", "ArrowLeft", "ArrowRight"].includes(e)
  ) {
    showAlert(TYPE.WARNING, t("Flow.KeyIncluedSpecialChar"));
    isSpecialCharEntered.value = true;
    val = "";
    return;
  }
  if (
    key === "itemKey" &&
    userDefinedVariables.value.some((item) => item.itemKey === e)
  ) {
    showAlert(TYPE.WARNING, t("Flow.KeyIsAlreadyExist"));
  }
  userDefinedVariables.value[index][key] = val;
  isAnyChange.value = true;
  EventBus.isAnyChange = true;
  isSpecialCharEntered.value = false;
}
async function removeUserDefinedVariables(index: number) {
  const udv = userDefinedVariables.value[index];
  const key = udv.value.itemKey;
  if (!key) {
    userDefinedVariables.value.splice(index, 1);
    isAnyChange.value = true;
    return;
  }
  const removed = await confirmAndRemoveUdv(
    key,
    index,
    userDefinedVariables.value,
    steps.value,
    t
  );
  if (removed) {
    isAnyChange.value = true;
    EventBus.isAnyChange = true;
  }
}

function isDuplicateKeys() {
  const itemKeys = [];

  userDefinedVariables.value.forEach((item) => {
    itemKeys.push(item.value.itemKey);
  });

  const duplicates = itemKeys.reduce((acc, curr, index, self) => {
    if (self.indexOf(curr) !== index && !acc.includes(curr)) {
      acc.push(curr);
    }
    return acc;
  }, []);

  return duplicates.length > 0;
}

function formatUserDefinedVariables() {
  const formattedObj = {};

  userDefinedVariables.value.forEach((item) => {
    if (item.value.itemKey && item.value.itemKey.trim() !== "") {
      let value = "";
      try {
        value = JSON.parse(item.value.itemValue);
      } catch (error) {
        value = item.value.itemValue;
      }
      formattedObj[item.value.itemKey] = value;
    }
  });

  return formattedObj;
}
function parseUserDefinedVariables(userDefVar) {
  if (userDefVar === undefined || userDefVar === null) return;
  const userDefVarArr = Object.entries(userDefVar);
  userDefinedVariables.value = [];

  userDefVarArr.forEach(([key, value]) => {
    const parsedValue =
      typeof value === "string" ? value : JSON.stringify(value);
    const itemObj = ref({
      itemKey: key,
      itemValue: parsedValue,
    });
    userDefinedVariables.value.push(itemObj);
  });
}

function getSizeByValue(size) {
  switch (size) {
    case 0:
      return "small";
    case 1:
      return "medium";
    case 2:
      return "large";
    default:
      return "medium";
  }
}

function getSizeByString(size) {
  switch (size) {
    case "small":
      return 0;
    case "medium":
      return 1;
    case "large":
      return 2;
    default:
      return 1;
  }
}

function closeContextMenu() {
  contextMenuVisible.value = false;
  contextMenuIndex.value = -1;
  contextMenuStep.value = null;
}

function changeFilter(filter) {
  if (selectedStep.value) {
    updateStepsFilter(steps.value, filter, selectedStep.value);
    updateStepsFilter(allStep.value, filter, selectedStep.value);
  }
}

async function removeFilter() {
  const isConfirmed = await showConfirm(
    "warning",
    t("Common.DeleteFilter"),
    t("Common.DeleteFilterMessage")
  );

  if (!isConfirmed) {
    return;
  }

  changeFilter([]);
  updateStep(true);
  showCondition();
}

function changeDelay(delay) {
  if (selectedStep.value) {
    updateStepsDelay(steps.value, delay, selectedStep.value);
    updateStepsDelay(allStep.value, delay, selectedStep.value);
  }
}

function saveShortCut(event) {
  if (activeTab.value === 1) {
    if (!(event.keyCode === 83 && (event.ctrlKey || event.metaKey))) {
      return;
    }
    event.preventDefault();
    if (!shortCutPressed.value && !responseLoading.value) {
      shortCutPressed.value = true;
      if (flowId.value && !flow.value.latest) {
        flowRevert();
      } else {
        onFlowSubmit();
      }
    }
  }
}

function changeFunctionsVisible(val) {
  functionsVisible.value = val;
}

function updateCronExpr(type, schedule, timeZone) {
  flow.value.scheduleType = type;
  flow.value.schedule = schedule;
  // Java normalized against this zone, so it is the flow's canonical one.
  flow.value.timeZone = timeZone;
  fetchTimezone();
}

function handleScheduleTypeChange() {
  selectedOffset.value = null;
  flow.value.timeZone = undefined;
  nextRunTime.value = "";
}

function resetUnsavedState() {
  isAnyChange.value = false;
  EventBus.isAnyChange = false;
}

function clearFlowDiagramDirtyReleaseTimers() {
  if (flowDiagramDirtyReleaseTimer) {
    clearTimeout(flowDiagramDirtyReleaseTimer);
    flowDiagramDirtyReleaseTimer = null;
  }
}

function beginFlowDiagramInitialSync() {
  clearFlowDiagramDirtyReleaseTimers();
  suppressFlowDiagramDirty.value = true;
  console.debug("[EditVueFlow] flow snapshot sync guard started", {
    flowId: flowId.value,
    version: version.value,
  });
}

function releaseFlowDiagramInitialSyncAfterFlush() {
  clearFlowDiagramDirtyReleaseTimers();
  flowDiagramDirtyReleaseTimer = setTimeout(() => {
    suppressFlowDiagramDirty.value = false;
    flowDiagramDirtyReleaseTimer = null;
    console.debug("[EditVueFlow] flow snapshot sync guard released", {
      flowId: flowId.value,
      version: version.value,
    });
  }, FLOW_DIAGRAM_INITIAL_SYNC_IDLE_MS);
}

function isFlowDiagramInitialSync(initialLoad?: boolean) {
  return Boolean(initialLoad || suppressFlowDiagramDirty.value);
}

async function navigateToSavedFlowVersion(response: {
  id: string;
  version: string | number;
  newUi?: boolean;
}) {
  const targetRouteName =
    response?.newUi === false ? "editFlows" : "editFlowsRouteNew";

  await router.push({
    name: targetRouteName,
    params: { id: response.id, version: response.version },
  });
}

// Lets the save path settle a debounced schedule normalization before persisting.
const cronEditorRef = ref<{
  flushSchedule: () => Promise<boolean>;
  scheduleError: string;
} | null>(null);
function setEditorVisible(val) {
  cronEditorVisible.value = val;
}

function onFilterRemoved(stepId: string) {
  if (
    conditionVisible.value &&
    selectedStep.value &&
    selectedStep.value.id === stepId
  ) {
    showCondition();
  }
}

function resolveFreshStep(step) {
  if (!step) {
    return step;
  }
  const positioned = useAddPositionToStep(
    steps.value,
    flow.value?.flowLines ?? flowLines.value
  );
  return findStepForSelection(positioned, step) ?? step;
}

function flushCurrentEditStepState() {
  if (drawerVisible.value && editStepRef.value) {
    editStepRef.value.updateCurrentSavedData();
    recomputeOutputLists();
    debouncedRecomputeOutputLists.cancel();
  }
}

function showCondition(index?, step?) {
  if (index === undefined && step === undefined) {
    conditionVisible.value = false;
    selectedStep.value = null;
    selectedIndex.value = undefined;
    return;
  }

  flushCurrentEditStepState();

  drawerVisible.value = false;
  wizardDrawerVisible.value = false;
  delayVisible.value = false;
  infoVisible.value = false;
  userVariableVisible.value = false;
  configurationVisible.value = false;
  routerVisible.value = false;
  loopVisible.value = false;
  functionsVisible.value = false;

  const freshStep = resolveFreshStep(step);

  if (freshStep && !freshStep.filter) {
    freshStep.filter = [];
  }

  if (conditionVisible.value && selectedStep.value?.id === freshStep?.id) {
    conditionVisible.value = false;
    selectedStep.value = null;
    selectedIndex.value = undefined;
    return;
  }

  if (conditionVisible.value) {
    conditionVisible.value = false;
    nextTick(() => {
      selectedStep.value = freshStep!;
      selectedIndex.value = index!;
      conditionVisible.value = true;
    });
  } else {
    selectedStep.value = freshStep!;
    selectedIndex.value = index!;
    conditionVisible.value = true;
  }
}

function openDelay(index?, step?) {
  if (delayVisible.value) {
    selectedIndex.value = -1;
    selectedStep.value = null;
    functionsVisible.value = false;
    delayVisible.value = !delayVisible.value;
  } else {
    flushCurrentEditStepState();
    drawerVisible.value = false;
    infoVisible.value = false;
    wizardDrawerVisible.value = false;
    userVariableVisible.value = false;
    configurationVisible.value = false;
    conditionVisible.value = false;
    routerVisible.value = false;
    loopVisible.value = false;
    selectedIndex.value = index;
    selectedStep.value = resolveFreshStep(step);
    delayVisible.value = !delayVisible.value;
  }
}

function openOutput(index?, step?) {
  if (visibleOutputDailog.value) {
    visibleOutputDailog.value = false;
    showingStepOutputData.output = "";
  }
  if (!step) {
    return;
  }
  flushCurrentEditStepState();
  const freshStep = resolveFreshStep(step);
  setTimeout(() => {
    const parsed = JSON.parse(JSON.stringify(freshStep));
    showingStepOutputData.output = parsed.output;
    showingStepOutputData.displayNumber = getStepDisplayNumber(
      parsed.index,
      parsed.stepNumber
    );
    visibleOutputDailog.value = true;
  }, 10);
}

function setActive(tab) {
  infoVisible.value = false;
  wizardDrawerVisible.value = false;
  userVariableVisible.value = false;
  configurationVisible.value = false;
  selectedStep.value = undefined;
  selectedIndex.value = undefined;
  drawerVisible.value = false;
  loopVisible.value = false;
  conditionVisible.value = false;
  functionsVisible.value = false;
  delayVisible.value = false;

  activeTab.value = tab;
}

function updateSelectedStepByIxIy(stepList, currentStep) {
  if (!currentStep) return;

  const foundStep = findStepForSelection(stepList, currentStep);
  if (foundStep) {
    selectedStep.value = { ...foundStep };
    return;
  }

  if (
    currentStep.id ||
    currentStep.parentId ||
    currentStep.uniqueId !== undefined
  ) {
    return;
  }

  stepList.forEach((step) => {
    if (!step.type || step.type === "LOOP" || step.type === "LOOP_END") {
      if (step.ix === currentStep.ix && step.iy === currentStep.iy) {
        selectedStep.value = { ...step };
      }
    } else {
      step.routes.forEach((items) => {
        updateSelectedStepByIxIy(items.steps, currentStep);
      });
    }
  });
}

function setActiveOne() {
  activeTab.value = 1;
}
function outputListChanged() {
  organizeOutputData(steps.value);
}

function routerOutputList() {
  if (!selectedStep.value) return [];
  const available = Array.isArray(selectedStep.value.availableOutput)
    ? selectedStep.value.availableOutput
    : [];
  const routerStepOrigIds =
    selectedStep.value.type === "ROUTER"
      ? collectAllRouterStepOrigIds(selectedStep.value)
      : null;

  return outputList.value.filter(
    (item) =>
      (available.some((x) => x.uniqueId === item.uniqueId) ||
        (selectedStep.value.uniqueId === item.uniqueId && !item.type)) &&
      (!routerStepOrigIds ||
        !item?.origId ||
        !routerStepOrigIds.has(item.origId))
  );
}

function routerMetaoutputList() {
  if (!selectedStep.value) return [];
  const available = Array.isArray(selectedStep.value.availableMetaoutput)
    ? selectedStep.value.availableMetaoutput
    : [];
  const routerStepOrigIds =
    selectedStep.value.type === "ROUTER"
      ? collectAllRouterStepOrigIds(selectedStep.value)
      : null;

  return metaoutputList.value.filter(
    (item) =>
      (available.some((x) => x.uniqueId === item.uniqueId) ||
        (selectedStep.value.uniqueId === item.uniqueId && !item.type)) &&
      (!routerStepOrigIds ||
        !item?.origId ||
        !routerStepOrigIds.has(item.origId))
  );
}

function organizeSteps(stepList = allStep.value, buttonClicked = true) {
  startStepPosition.value = -200;

  if (!buttonClicked) {
    steps.value = [...stepList];
    allStep.value = [...stepList];
    syncOpenDrawerSelection(stepList, { refreshKeys: false });
    return;
  }

  const currentFlowLines = Array.isArray(flow.value?.flowLines)
    ? flow.value.flowLines
    : flowLines.value;
  const layoutPlan = createDetachedLayoutPlan(stepList, currentFlowLines);
  const hasLayoutGroups =
    layoutPlan.attachedGroups.length > 0 ||
    layoutPlan.detachedGroups.length > 0;

  const findFirstIncludedStep = (
    list: any[],
    includedOrigIds: Set<string>
  ): any | null => {
    if (!Array.isArray(list)) return null;

    for (let index = 0; index < list.length; index += 1) {
      const step = list[index];
      if (includedOrigIds.has(getOrigKey(step))) {
        return step;
      }

      if (Array.isArray(step?.routes)) {
        for (
          let routeIndex = 0;
          routeIndex < step.routes.length;
          routeIndex += 1
        ) {
          const found = findFirstIncludedStep(
            step.routes[routeIndex]?.steps || [],
            includedOrigIds
          );
          if (found) return found;
        }
      }

      if (Array.isArray(step?.steps) && step.steps.length > 0) {
        const found = findFirstIncludedStep(step.steps, includedOrigIds);
        if (found) return found;
      }
    }

    return null;
  };

  const parseFlowLineData = (line: any) => {
    if (!line?.data) return {};
    if (typeof line.data === "object") return line.data;

    try {
      return JSON.parse(line.data);
    } catch {
      return {};
    }
  };

  const isVisibleFlowLine = (line: any) =>
    line && !line.hidden && !parseFlowLineData(line).hidden;

  const alignRootLoopsToNestedSources = (rootSteps: any[]) => {
    if (!Array.isArray(rootSteps) || !Array.isArray(currentFlowLines)) return;

    rootSteps.forEach((step) => {
      if (step?.type !== "LOOP" || !step?.origId) return;

      const targetResult = findStepByOrigId(stepList, step.origId);
      if (!targetResult || targetResult.steps !== stepList) return;

      const nestedSource = currentFlowLines
        .filter(
          (line: any) =>
            isVisibleFlowLine(line) &&
            String(line?.target ?? "") === String(step.origId)
        )
        .map((line: any) => findStepByOrigId(stepList, line.source)?.step)
        .find((sourceStep: any) => {
          if (!sourceStep?.origId) return false;

          const sourceResult = findStepByOrigId(stepList, sourceStep?.origId);
          return (
            sourceResult &&
            sourceResult.steps !== stepList &&
            typeof sourceStep?.position?.y === "number"
          );
        });

      if (
        !nestedSource ||
        typeof nestedSource.position?.y !== "number" ||
        typeof step.position?.y !== "number"
      ) {
        return;
      }

      const deltaY = nestedSource.position.y - step.position.y;
      if (!deltaY) return;

      const structureRange = getStructureRange(stepList, targetResult.index);
      const structureSteps = collectStructureSteps(stepList, structureRange);
      shiftStructureSteps(
        structureSteps.length ? structureSteps : [step],
        0,
        deltaY,
        layoutPlan.mainActiveStepOrigIds
      );
    });
  };

  if (hasLayoutGroups) {
    const mainActiveRootSteps = stepList.filter((step: any) =>
      layoutPlan.mainActiveStepOrigIds.has(getOrigKey(step))
    );

    withFilteredRouteSteps(
      mainActiveRootSteps,
      layoutPlan.mainActiveStepOrigIds,
      () =>
        applyOrganizedLayout(mainActiveRootSteps, {
          movableOrigIds: layoutPlan.mainActiveStepOrigIds,
        })
    );
    alignRootLoopsToNestedSources(mainActiveRootSteps);

    layoutPlan.attachedGroups.forEach((group) => {
      withFilteredRouteSteps(group.rootSteps, group.origIds, () =>
        applyOrganizedLayout(group.rootSteps, { movableOrigIds: group.origIds })
      );

      const bounds = getStepsBounds(group.steps);
      const anchorStep = group.anchorOrigIds
        .map((origId) => findStepByOrigId(stepList, origId)?.step)
        .find(
          (step) =>
            typeof step?.position?.x === "number" &&
            typeof step?.position?.y === "number"
        );

      if (bounds && anchorStep) {
        shiftStructureSteps(
          group.steps,
          anchorStep.position.x + STRUCTURE_HORIZONTAL_GAP - bounds.minX,
          anchorStep.position.y - bounds.minY
        );
      }
    });

    const detachedLayouts: Array<{
      group: (typeof layoutPlan.detachedGroups)[number];
      bounds: NonNullable<ReturnType<typeof getStepsBounds>>;
    }> = [];

    layoutPlan.detachedGroups.forEach((group) => {
      withFilteredRouteSteps(group.rootSteps, group.origIds, () => {
        applyOrganizedLayout(group.rootSteps, {
          applySpacing: false,
          movableOrigIds: group.origIds,
        });
        compactDetachedGroupLayout(group.rootSteps, {
          horizontalGap: STRUCTURE_HORIZONTAL_GAP,
          routeVerticalGap: ROUTE_VERTICAL_GAP,
        });
      });

      const bounds = getStepsBounds(group.steps);
      if (bounds) {
        detachedLayouts.push({ group, bounds });
      }
    });

    const activeBounds = getStepsBounds(layoutPlan.activeSteps);
    const firstActiveStep = findFirstIncludedStep(
      stepList,
      layoutPlan.activeStepOrigIds
    );
    const firstActiveX =
      typeof firstActiveStep?.position?.x === "number"
        ? firstActiveStep.position.x
        : activeBounds?.minX ?? 0;
    const activeTopY = activeBounds?.minY ?? 0;
    const maxDetachedHeight = detachedLayouts.reduce(
      (max, { bounds }) => Math.max(max, bounds.maxY - bounds.minY),
      0
    );
    const detachedTopY = activeTopY - maxDetachedHeight - ROUTE_VERTICAL_GAP;
    let detachedCursorX = firstActiveX;

    detachedLayouts.forEach(({ group, bounds }) => {
      shiftStructureSteps(
        group.steps,
        detachedCursorX - bounds.minX,
        detachedTopY - bounds.minY
      );
      detachedCursorX += bounds.maxX - bounds.minX + STRUCTURE_HORIZONTAL_GAP;
    });
  } else {
    applyOrganizedLayout(stepList);
  }

  steps.value = [...stepList];
  allStep.value = [...stepList];
  syncOpenDrawerSelection(stepList, { refreshKeys: true });
}

function showUserVariables() {
  if (userVariableVisible.value) {
    userVariableVisible.value = false;
  } else {
    closeDrawer();
    wizardDrawerVisible.value = false;
    conditionVisible.value = false;
    delayVisible.value = false;
    routerVisible.value = false;
    loopVisible.value = false;
    configurationVisible.value = false;
    infoVisible.value = false;
    if (activeTab.value !== 1) {
      activeTab.value = 1;
    }
    userVariableVisible.value = true;
  }
}

function showInfo() {
  if (infoVisible.value) {
    infoVisible.value = false;
  } else {
    closeDrawer();
    wizardDrawerVisible.value = false;
    userVariableVisible.value = false;
    configurationVisible.value = false;
    conditionVisible.value = false;
    delayVisible.value = false;
    routerVisible.value = false;
    loopVisible.value = false;
    if (activeTab.value !== 1) {
      activeTab.value = 1;
    }
    infoVisible.value = true;
    nextTick(() => nameInputField.value.focus());
  }
}

function setLoading(loading) {
  stepLoading.value = loading;
}

async function getSysVariables() {
  await getSystemVariables().then((response) => {
    systemVariables.value = response;
  });
}
async function getSelectedFlow(
  {
    doNotUpdateFlow = false,
    newFlow = undefined,
  }: { doNotUpdateFlow?: boolean; newFlow?: any } = {
    doNotUpdateFlow: false,
    newFlow: undefined,
  }
) {
  if (flowId.value && version.value) {
    let currentFlow;
    if (!newFlow) {
      currentFlow = await getFlow(flowId.value, version.value);
    } else {
      currentFlow = newFlow;
    }
    beginFlowDiagramInitialSync();
    try {
      if (!doNotUpdateFlow) {
        flow.value = currentFlow;
        if (flowId.value) {
          const stored = restoreSkillGenerationToggle(flowId.value);
          if (stored !== undefined) {
            flow.value.skillGenerationEnabled = stored;
          }
        }
      }
      // Restore stepNumber from backend's ix before useAddPositionToStep overwrites ix
      if (flow.value.newUi) {
        restoreStepNumbersFromIx(currentFlow.steps, flow.value);
      }
      steps.value = useAddPositionToStep(
        cloneDeep(currentFlow.steps),
        cloneDeep(currentFlow.flowLines)
      );
      flowLines.value = cloneDeep(currentFlow.flowLines);
      updateSelectedStepByIxIy(steps.value, selectedStep.value);

      // Migrate step numbers
      if (flow.value.newUi) {
        migrateStepNumbers(steps.value, flow.value);
      }
      allStep.value = cloneDeep(steps.value);
      if (!pageLoading.value) {
        releaseFlowDiagramInitialSyncAfterFlush();
      }

      if (currentFlow.modifiedBy != null) {
        updatedByName.value = await getModifiedUser(currentFlow.modifiedBy);
      }

      if (currentFlow != null) {
        createdAtDate.value = await getCreatedAtByFlowIdAndVersion(
          currentFlow.id,
          1
        );
        createdById.value = await getCreatedByByFlowIdAndVersion(
          currentFlow.id,
          1
        );
        createdByName.value = await getUserById(createdById.value);
      }
      parseUserDefinedVariables(flow.value.userDefinedVariables);

      flowStatus.value = flow.value.flowStatusType;
      organizeOutputData(steps.value);
      changeDrawerData();
      changeListItemOfBreadcrumb({
        labelKey: "Common.Edit",
        route: "",
        disabled: true,
        isTranslated: false,
        uniqueLabel: `${flow.value.name} / v.${flow.value.version}`,
      });
      if (flow.value.schedule) {
        nextRunTime.value = flow.value.schedule.nextFireTime;
      }
      await fetchTimezone();
    } finally {
      if (
        !pageLoading.value &&
        suppressFlowDiagramDirty.value &&
        !flowDiagramDirtyReleaseTimer
      ) {
        releaseFlowDiagramInitialSyncAfterFlush();
      }
    }
  }
}
function organizeOutputData(stepList) {
  const currentFlowLines = flow.value?.flowLines ?? flowLines.value;
  const positioned = useAddPositionToStep(stepList, currentFlowLines);
  const nextOutputList = getOutputListForAllStep(positioned, {
    useStableIndex: true,
    skipPositioning: true,
  });
  const nextMetaoutputList = getMetaoutputListForAllStep(positioned, {
    useStableIndex: true,
    skipPositioning: true,
  });

  outputList.value = sortOutputItemsByGraphOrder(
    nextOutputList,
    positioned,
    currentFlowLines
  );
  metaoutputList.value = sortOutputItemsByGraphOrder(
    nextMetaoutputList,
    positioned,
    currentFlowLines
  );
  debouncedRecomputeOutputLists.cancel();
}
function handleClickOutside(event) {
  const target = event?.target;
  if (target instanceof Element && target.closest(".closest-node-container")) {
    return;
  }

  if (conditionVisible.value) {
    showCondition();
    return;
  }

  closeDrawer();
  closeRouterSettings();
}

function openDrawer(
  step,
  index,
  insideRouter,
  options?: { skipSave?: boolean }
) {
  if (!stepLoading.value) {
    if (
      drawerVisible.value &&
      selectedStep.value &&
      selectedStep.value.id === step.id
    ) {
      closeDrawer();
    } else {
      if (drawerVisible.value && editStepRef.value && !options?.skipSave) {
        editStepRef.value.updateCurrentSavedData();
        recomputeOutputLists();
        debouncedRecomputeOutputLists.cancel();
      }
      functionsVisible.value = false;
      infoVisible.value = false;
      userVariableVisible.value = false;
      configurationVisible.value = false;
      routerVisible.value = false;
      loopVisible.value = false;
      conditionVisible.value = false;
      delayVisible.value = false;
      selectedIndex.value = index;
      const stepList = useAddPositionToStep(
        steps.value,
        flow.value?.flowLines ?? flowLines.value
      );
      updateSelectedStep(stepList, step);
      isStepInRouter.value = !!insideRouter;
      drawerVisible.value = true;
      editStepKey.value++;
      loopDrawerKey.value++;
      setTimeout(
        () => {
          fitView({
            nodes: [step.origId],
            duration: 400,
            padding: 4,
          }).then(() => {
            anyPrevDrawerOpen.value = false;
          });
        },
        anyPrevDrawerOpen.value ? 200 : 100
      );
    }
  }
}

function openRouterSettings(
  step,
  index,
  listIndex,
  options?: { skipSave?: boolean }
) {
  if (
    routerVisible.value &&
    selectedStep.value &&
    selectedStep.value.id === step.id
  ) {
    closeRouterSettings();
  } else {
    drawerVisible.value = false;
    infoVisible.value = false;
    delayVisible.value = false;
    if (!options?.skipSave) {
      if (editStepRef.value) {
        editStepRef.value.updateCurrentSavedData();
        recomputeOutputLists();
        debouncedRecomputeOutputLists.cancel();
      }
    }
    conditionVisible.value = false;
    userVariableVisible.value = false;
    configurationVisible.value = false;
    routerVisible.value = true;
    loopVisible.value = false;
    functionsVisible.value = false;
    selectedIndex.value = index;
    const stepList = useAddPositionToStep(
      steps.value,
      flow.value?.flowLines ?? flowLines.value
    );
    const found = updateSelectedStep(stepList, step);
    if (!found) {
      selectedStep.value = step;
    }
    routerListIndex.value = listIndex;
    routerDrawerKey.value++;
    // fitView runs and center the seleted step on drawer open of each step
    setTimeout(() => {
      fitView({
        nodes: [step.origId],
        duration: 400,
        padding: 4,
      });
    }, 100);
  }
}

function openLoopSettings(
  step,
  index,
  listIndex,
  options?: { skipSave?: boolean }
) {
  if (
    loopVisible.value &&
    selectedStep.value &&
    selectedStep.value.id === step.id
  ) {
    closeLoopSettings();
  } else {
    drawerVisible.value = false;
    infoVisible.value = false;
    delayVisible.value = false;
    if (!options?.skipSave) {
      if (editStepRef.value) {
        editStepRef.value.updateCurrentSavedData();
        recomputeOutputLists();
        debouncedRecomputeOutputLists.cancel();
      }
    }
    conditionVisible.value = false;
    routerVisible.value = false;
    userVariableVisible.value = false;
    configurationVisible.value = false;
    loopVisible.value = true;
    functionsVisible.value = false;
    selectedIndex.value = index;
    const stepList = useAddPositionToStep(
      steps.value,
      flow.value?.flowLines ?? flowLines.value
    );
    updateSelectedStep(stepList, step);
    routerListIndex.value = listIndex;
    // fitView runs and center the seleted step on drawer open of each step
    setTimeout(() => {
      fitView({
        nodes: [step.origId],
        duration: 400,
        padding: 4,
      });
    }, 100);
  }
}

function closeRouterSettings() {
  if (dragScrollActive.value) return;
  selectedIndex.value = undefined;
  selectedStep.value = undefined;
  routerVisible.value = false;
  functionsVisible.value = false;
  routerListIndex.value = undefined;
}

function closeLoopSettings() {
  if (dragScrollActive.value) return;
  selectedIndex.value = undefined;
  selectedStep.value = undefined;
  loopVisible.value = false;
  functionsVisible.value = false;
  routerListIndex.value = undefined;
}

function closeDrawer() {
  if (dragScrollActive.value) return;
  if (!stepLoading.value) {
    // eslint-disable-next-line no-unused-expressions
    editStepRef.value?.updateCurrentSavedData();
    if (editStepRef.value) {
      recomputeOutputLists();
      debouncedRecomputeOutputLists.cancel();
    }
  }
  isStepInRouter.value = false;
  selectedIndex.value = undefined;
  selectedStep.value = undefined;
  drawerVisible.value = false;
  loopVisible.value = false;
  routerVisible.value = false;
  functionsVisible.value = false;
  delayVisible.value = false;
}

function updateStep(isChanged) {
  isAnyChange.value = isChanged;
  EventBus.isAnyChange = isChanged;
}

function onFlowChange() {
  isAnyChange.value = true;
  EventBus.isAnyChange = true;
}

function handleTimezoneChange(offset: string) {
  const timezoneValue = timezoneOffsets.find((tz) => tz.offset === offset);
  if (timezoneValue) {
    selectedOffset.value = offset;
    selectedIdentifier.value = timezoneValue.identifier;
    flow.value.timeZone = selectedIdentifier.value;
  }
}

async function fetchTimezone() {
  const identifier = flow.value.timeZone;
  const timezoneValue = timezoneOffsets.find(
    (tz) => tz.identifier === identifier
  );
  if (timezoneValue) {
    selectedOffset.value = timezoneValue.offset;
    selectedIdentifier.value = timezoneValue.identifier;
  }
}

function onStepChange(index, stepData) {
  if (stepData?.name && stepData?.name.length > charLimit.value) {
    const shortenedName = stepData.name.substring(0, 50);
    showAlert(
      TYPE.ERROR,
      t("Common.StepNameCharLimitWarning", {
        limit: charLimit.value,
        name: shortenedName,
      })
    );
    isStepNameExceedingCharLimit.value = true;
    return;
  }
  isStepNameExceedingCharLimit.value = false;
  // Position data and output lists don't change during typing —
  // the deep watcher on steps.value handles output recomputation.
  updateStepData(steps.value, stepData);
  updateStepData(allStep.value, stepData);
}

function updateStepData(stepList, stepData) {
  stepList.forEach((step, index) => {
    if (!step.type || step.type === "LOOP" || step.type === "LOOP_END") {
      if (step.id === stepData.id) {
        stepList[index] = stepData;
      }
    } else {
      step.routes.forEach((items) => {
        updateStepData(items.steps, stepData);
      });
    }
  });
}

function onRouterChange(index, routerStep) {
  const existingRouter = findStepByOrigId(steps.value, routerStep.origId);
  const previousRoutes = Array.isArray(existingRouter?.step?.routes)
    ? existingRouter.step.routes
    : [];
  const nextRouteIds = new Set(
    Array.isArray(routerStep?.routes)
      ? routerStep.routes.map((route: any) => route?.id)
      : []
  );
  const removedRouteIndex =
    previousRoutes.length > (routerStep?.routes?.length ?? 0)
      ? previousRoutes.findIndex((route: any) => !nextRouteIds.has(route?.id))
      : -1;
  const removedRouteBounds =
    removedRouteIndex !== -1
      ? getListBounds(previousRoutes[removedRouteIndex]?.steps || [])
      : null;

  // Update by origId instead of ix/iy
  updateRouteStepByOrigId(steps.value, routerStep);
  updateRouteStepByOrigId(allStep.value, routerStep);

  if (removedRouteIndex !== -1 && removedRouteBounds) {
    const updatedRouter = findStepByOrigId(steps.value, routerStep.origId);

    if (updatedRouter?.step) {
      const movableOrigIds = getVisibleConnectedStepOrigIds(
        steps.value,
        flow.value?.flowLines ?? flowLines.value,
        routerStep.origId
      );
      let cursorY = removedRouteBounds.minY;

      if (removedRouteIndex > 0) {
        const previousRouteBounds = getListBounds(
          updatedRouter.step.routes?.[removedRouteIndex - 1]?.steps || []
        );

        if (previousRouteBounds) {
          cursorY = Math.max(
            cursorY,
            previousRouteBounds.maxY + ROUTE_VERTICAL_GAP
          );
        }
      }

      shiftRouteSiblingBranchesUp(
        updatedRouter.step,
        removedRouteIndex,
        cursorY,
        ROUTE_VERTICAL_GAP,
        movableOrigIds
      );
      compactRouterSiblingBranchesLeft(
        updatedRouter.step,
        STRUCTURE_HORIZONTAL_GAP,
        movableOrigIds
      );
      applyHorizontalShrinkShift({
        rootSteps: steps.value,
        targetList: updatedRouter.steps,
        structureIndex: updatedRouter.index,
        gap: STRUCTURE_HORIZONTAL_GAP,
        routeGap: ROUTE_VERTICAL_GAP,
        movableOrigIds,
      });
    }
  }

  steps.value = useAddPositionToStep(
    [...steps.value],
    flow.value?.flowLines ?? flowLines.value
  );
  allStep.value = useAddPositionToStep(
    [...steps.value],
    flow.value?.flowLines ?? flowLines.value
  );
}

function updateRouteNameLabel({
  routeId,
  name,
}: {
  routeId: string;
  name: string;
}) {
  if (flowDiagramRef.value) {
    flowDiagramRef.value.updateRouteNameLabel(routeId, name);
  }
}

function updateRouteStepByOrigId(stepList: any[], routeStep: any) {
  for (let i = 0; i < stepList.length; i++) {
    const step = stepList[i];

    if (step.type === "ROUTER") {
      if (step.origId === routeStep.origId) {
        stepList[i] = { ...routeStep };
        return true;
      }

      if (Array.isArray(step.routes)) {
        const found = step.routes.some((route: any) =>
          updateRouteStepByOrigId(route.steps, routeStep)
        );
        if (found) return true;
      }
    }
  }
  return false;
}

function updateRouteStep(stepList, routeStep) {
  stepList.forEach((step, index) => {
    if (step.type && step.type !== "LOOP" && step.type !== "LOOP_END") {
      if (step.ix === routeStep.ix && step.iy === routeStep.iy) {
        stepList[index] = routeStep;
      } else {
        step.routes.forEach((list) => {
          updateRouteStep(list.steps, routeStep);
        });
      }
    }
  });
}

function onLoopChange(
  index,
  contentPath,
  stepId,
  loopType = "SPLIT",
  loopConfig
) {
  const path = contentPath;
  updateLoopStep(steps.value, stepId, path, loopType, loopConfig);
}

function updateLoopStep(
  stepList,
  stepId,
  contentPath,
  loopType = "SPLIT",
  loopConfig: any = undefined
) {
  let foundStep = null;

  stepList.some((step) => {
    if (!step.type || step.type === "LOOP" || step.type === "LOOP_END") {
      if (step.id === stepId) {
        step.contentPath = contentPath;
        if (step.type === "LOOP") {
          step.loopType = loopType;
          step.loopConfig = normalizeLoopConfig(
            loopConfig ?? step.loopConfig,
            loopType
          );
        }
        updateStepData(steps.value, step);
        updateStepData(allStep.value, step);
        foundStep = step;
        return true;
      }
    } else {
      step.routes.some((list) => {
        const updatedStep = updateLoopStep(
          list.steps,
          stepId,
          contentPath,
          loopType,
          loopConfig
        );
        if (!updatedStep) return false;
        foundStep = updatedStep;
        return true;
      });
    }

    return Boolean(foundStep);
  });

  return foundStep;
}

function updateStepsFilter(stepList, filter, filterStep) {
  stepList.forEach((step) => {
    if (!step.type || step.type === "LOOP" || step.type === "LOOP_END") {
      if (step.id === filterStep.id) {
        step.filter = filter;
      }
    } else {
      step.routes.forEach((items) => {
        updateStepsFilter(items.steps, filter, filterStep);
      });
    }
  });
}

function updateSelectedStep(stepList, currentStep) {
  const foundStep = findStepForSelection(stepList, currentStep);
  if (foundStep && !isEqual(foundStep, selectedStep.value)) {
    selectedStep.value = { ...foundStep };
  }
  return foundStep;
}

function syncOpenDrawerSelection(
  stepList: any[],
  options?: { refreshKeys?: boolean }
) {
  const refreshKeys = options?.refreshKeys ?? true;
  if (!selectedStep.value) return;

  if (drawerVisible.value) {
    const stepData = updateSelectedStep(stepList, selectedStep.value);
    if (stepData && refreshKeys) {
      editStepKey.value++;
    }
  }

  if (routerVisible.value) {
    const stepData = updateSelectedStep(stepList, selectedStep.value);
    if (stepData && refreshKeys) {
      routerDrawerKey.value++;
    }
  }

  if (loopVisible.value && selectedStep.value.uniqueId) {
    if (refreshKeys) {
      // eslint-disable-next-line
      editLoopRef.value?.updateCurrentSavedData?.();
    }
    const flowData = {
      ...flow.value,
      steps: stepList,
    } as FlowType;

    const stepData = findStepForDrawer(flowData, selectedStep.value);
    if (stepData) {
      if (!isEqual(stepData, selectedStep.value)) {
        selectedStep.value = stepData;
      }
      if (refreshKeys) {
        loopDrawerKey.value++;
      }
    }
  }
}

function updateStepsDelay(stepList, delay, delayStep) {
  stepList.forEach((step) => {
    if (!step.type || step.type === "LOOP" || step.type === "LOOP_END") {
      if (step.id === delayStep.id) {
        step.delay = delay;
      }
    } else {
      step.routes.forEach((items) => {
        updateStepsDelay(items.steps, delay, delayStep);
      });
    }
  });
}

function collectStepOrigIdsByIds(stepList: any[], stepIds: Set<string>) {
  const origIds = new Set<string>();

  const visit = (list: any[]) => {
    if (!Array.isArray(list)) return;

    list.forEach((step: any) => {
      if (stepIds.has(String(step?.id)) && step?.origId) {
        origIds.add(String(step.origId));
      }

      if (Array.isArray(step?.routes)) {
        step.routes.forEach((route: any) => visit(route?.steps || []));
      }

      if (Array.isArray(step?.steps)) {
        visit(step.steps);
      }
    });
  };

  visit(stepList);
  return origIds;
}

function getLayoutChangedOrigIds(
  previousSteps: any[],
  nextSteps: any[],
  extra: any
) {
  const changedOrigIds = new Set<string>();
  const changedStepIds = new Set<string>();
  const payloads = [
    extra?.addedStep,
    extra?.removedStep,
    extra?.changedStep,
    extra?.step,
  ];

  payloads.forEach((payload) => {
    if (!payload) return;

    if (payload.origId) {
      changedOrigIds.add(String(payload.origId));
    }

    if (payload.step?.origId) {
      changedOrigIds.add(String(payload.step.origId));
    }

    if (payload.id) {
      changedStepIds.add(String(payload.id));
    }

    if (payload.step?.id) {
      changedStepIds.add(String(payload.step.id));
    }
  });

  const layoutChangedOrigIds = Array.isArray(extra?.layoutChangedOrigIds)
    ? extra.layoutChangedOrigIds
    : Array.from(extra?.layoutChangedOrigIds ?? []);

  layoutChangedOrigIds.forEach((origId: any) => {
    if (origId) {
      changedOrigIds.add(String(origId));
    }
  });

  collectStepOrigIdsByIds(previousSteps, changedStepIds).forEach((origId) =>
    changedOrigIds.add(origId)
  );
  collectStepOrigIdsByIds(nextSteps, changedStepIds).forEach((origId) =>
    changedOrigIds.add(origId)
  );

  return changedOrigIds;
}

function restoreUnchangedDetachedLayout(
  previousSteps: any[],
  nextSteps: any[],
  edgesArr: any,
  extra: any
) {
  restoreDetachedLayoutFields({
    sourceRootSteps: previousSteps,
    targetRootSteps: nextSteps,
    edges: edgesArr,
    changedOrigIds: getLayoutChangedOrigIds(previousSteps, nextSteps, extra),
  });
}

async function updateChangedList({
  extra,
  edgesArr,
  nodeList,
}: {
  extra: ChangedStep | AddedStep | RemovedStep;
  edgesArr: any;
  nodeList: any;
}) {
  await nextTick();

  const prevStepsSnapshot = cloneDeep(steps.value);

  // Use the steps.value which has the correct nested structure
  // and sync node properties into it
  let stepsThatPositionWasUpdated = syncNodePropertiesToSteps(
    cloneDeep(steps.value),
    nodeList
  );

  stepsThatPositionWasUpdated = useAddPositionToStep(
    stepsThatPositionWasUpdated,
    edgesArr
  );

  // Preserve hidden flag and properly serialize data
  const lines = edgesArr.map((item) => {
    const dataObj = typeof item.data === "object" ? item.data : {};
    return {
      ...item,
      hidden: item.hidden || false,
      data: JSON.stringify({
        ...dataObj,
        hidden: item.hidden || dataObj.hidden || false,
      }),
    };
  });

  if (edgesArr) {
    flow.value = { ...flow.value, flowLines: lines };
  }

  stepsThatPositionWasUpdated = syncOutputIndexReferencesNewUi({
    prevSteps: prevStepsSnapshot,
    nextSteps: stepsThatPositionWasUpdated,
  });
  restoreUnchangedDetachedLayout(
    prevStepsSnapshot,
    stepsThatPositionWasUpdated,
    edgesArr,
    extra
  );
  steps.value = [...stepsThatPositionWasUpdated];
  organizeOutputData(steps.value);
}

function syncNodePropertiesToSteps(
  stepsList: any[],
  nodeList: any[] = []
): any[] {
  if (!Array.isArray(nodeList)) return stepsList;

  const nodeMap = new Map<string, any>();
  nodeList.forEach((node) => {
    if (node.data?.origId) {
      nodeMap.set(node.data.origId, node.data);
    }
  });

  function syncSteps(stepsArr: any[]): any[] {
    return stepsArr.map((step) => {
      const nodeData = nodeMap.get(step.origId);

      const updatedStep = { ...step };
      if (nodeData) {
        // Position-related properties (calculated from edges)
        if (nodeData.ix !== undefined) updatedStep.ix = nodeData.ix;
        if (nodeData.index !== undefined) updatedStep.index = nodeData.index;
        if (nodeData.stepPosition !== undefined)
          updatedStep.stepPosition = nodeData.stepPosition;
        if (nodeData.position !== undefined)
          updatedStep.position = nodeData.position;

        // Connection status
        if (nodeData.active !== undefined) updatedStep.active = nodeData.active;

        // Chain validation flags
        if (nodeData.missingIncomingChain !== undefined) {
          updatedStep.missingIncomingChain = nodeData.missingIncomingChain;
        }
        if (nodeData.skipMissingIncomingChain !== undefined) {
          updatedStep.skipMissingIncomingChain =
            nodeData.skipMissingIncomingChain;
        }

        if (
          updatedStep.missingIncomingChain &&
          !updatedStep.skipMissingIncomingChain
        ) {
          updatedStep.active = false;
        } else if (updatedStep.missingIncomingChain === false) {
          updatedStep.active = true;
        }
      }

      // Recursively process routes
      if (updatedStep.type === "ROUTER" && Array.isArray(updatedStep.routes)) {
        updatedStep.routes = updatedStep.routes.map((route: any) => ({
          ...route,
          steps: syncSteps(route.steps || []),
        }));
      }

      return updatedStep;
    });
  }

  return syncSteps(stepsList);
}

function updateStepList({
  list,
  extra,
  onlyLineUpdate,
  edgesArr,
  initialLoad,
}: {
  list: any;
  extra: ChangedStep | AddedStep | RemovedStep;
  onlyLineUpdate: boolean;
  edgesArr: any;
  initialLoad?: boolean;
}) {
  const prevStepsSnapshot = cloneDeep(steps.value);
  let stepsThatPositionWasUpdated = useAddPositionToStep(
    preserveUdvChangeMaps(list, steps.value),
    edgesArr
  );

  const lines = edgesArr.map((item) => {
    // Preserve hidden flag
    const dataObj = typeof item.data === "object" ? item.data : {};
    return {
      ...item,
      hidden: item.hidden || false,
      data: JSON.stringify({
        ...dataObj,
        hidden: item.hidden || dataObj.hidden || false,
      }),
    };
  });

  if (edgesArr) {
    flow.value = { ...flow.value, flowLines: lines };
  }
  if (!onlyLineUpdate) {
    stepsThatPositionWasUpdated = syncOutputIndexReferencesNewUi({
      prevSteps: prevStepsSnapshot,
      nextSteps: stepsThatPositionWasUpdated,
    });
    restoreUnchangedDetachedLayout(
      prevStepsSnapshot,
      stepsThatPositionWasUpdated,
      edgesArr,
      extra
    );
  }

  // New UI line-only updates are currently hidden router-exit edge syncs.
  // Hidden edges are ignored by availableOutput; visible edge changes must
  // keep using onlyLineUpdate: false so parent step availability is refreshed.
  if (!onlyLineUpdate) {
    steps.value = cloneDeep(stepsThatPositionWasUpdated);
    allStep.value = cloneDeep(stepsThatPositionWasUpdated);
  }
  if (!onlyLineUpdate) {
    syncOpenDrawerSelection(stepsThatPositionWasUpdated, {
      refreshKeys: Boolean(extra),
    });
  }
  const initialDiagramSync = isFlowDiagramInitialSync(initialLoad);
  if (initialDiagramSync && suppressFlowDiagramDirty.value) {
    console.debug("[EditVueFlow] suppressed load-time diagram dirty update", {
      flowId: flowId.value,
      version: version.value,
      initialLoad,
      onlyLineUpdate,
      edgeCount: Array.isArray(edgesArr) ? edgesArr.length : 0,
      stepCount: Array.isArray(list) ? list.length : 0,
    });
    releaseFlowDiagramInitialSyncAfterFlush();
  }
  if (!initialDiagramSync) {
    console.debug("[EditVueFlow] diagram update marked flow dirty", {
      flowId: flowId.value,
      version: version.value,
      onlyLineUpdate,
      edgeCount: Array.isArray(edgesArr) ? edgesArr.length : 0,
      stepCount: Array.isArray(list) ? list.length : 0,
    });
    isAnyChange.value = true;
    EventBus.isAnyChange = true;
  }
}

function findStepForDrawer(flowData: FlowType, selected: any) {
  const list = flowData.steps ?? [];
  const bySelection = findStepForSelection(list, selected);
  if (bySelection) return bySelection;

  if (selected?.origId) {
    const byOrigId = findStepByOrigId(list, selected.origId);
    if (byOrigId?.step) return byOrigId.step;
  }

  return null;
}

async function updateEditFlow(data, doNotUpdateFlow = false) {
  connections.value = await getConnections();
  connectors.value = await getOrganizationsConnectorList();
  // If editing flow instead of creating
  if (flowId.value) {
    if (flowDiagramRef.value) flowDiagramRef.value.resetInitialLoad();
    await getSelectedFlow({ doNotUpdateFlow });
  }
  if (data) {
    componentKey.value++;
  }
}

function checkContentPaths(stepList) {
  let allLoopsHaveContentPath = true;

  stepList.forEach((step) => {
    if (step.type === "LOOP") {
      if (
        !step.contentPath ||
        step.contentPath === "[]" ||
        step.contentPath === ""
      ) {
        allLoopsHaveContentPath = false;
      }
    } else if (step.type === "ROUTER" && step.routes) {
      const routerResult = step.routes.every((route) =>
        checkContentPaths(route.steps)
      );
      if (!routerResult) {
        allLoopsHaveContentPath = false;
      }
    }
  });
  return allLoopsHaveContentPath;
}
async function updateConfigurationFrameworkValue(data, ownerId) {
  configResponseLoading.value = true;
  try {
    await updateConfigurationFramework(data, ownerId);
    getConfigurationVariables();
  } catch (error) {
    showAlert(TYPE.ERROR, t("Flow.ValueUpdatedError"));
  } finally {
    configResponseLoading.value = false;
  }
}
async function submitExecSwitch() {
  configResponseLoading.value = true;
  try {
    await updateConfiguraitonSettings(pendingData.value);
    getConfigurationVariables();
  } catch (error) {
    showAlert(TYPE.ERROR, t("Flow.ValueUpdatedError"));
  } finally {
    configResponseLoading.value = false;
  }
}
// OT-5040: submitFlow only sets responseLoading after its awaits and the step-tree walk, so
// repeated Save clicks in that window each sent a PUT /flows with the same version and the
// backend saved every one (steps duplicated per click). Hand concurrent callers the in-flight
// save instead of starting another; awaiting callers still resume once that save settles.
let inFlightSubmit: Promise<void> | null = null;
function onFlowSubmit() {
  if (!inFlightSubmit) {
    isSubmitting.value = true;
    inFlightSubmit = submitFlow().finally(() => {
      inFlightSubmit = null;
      isSubmitting.value = false;
    });
  }
  return inFlightSubmit;
}

async function submitFlow() {
  flushFlowInputs();
  await nextTick();

  // const isContentPathSet = checkContentPaths(steps.value) ?? true;
  const invalidVariables = userDefinedVariables.value.filter(
    (item) => !item.value.itemKey && item.value.itemValue
  );

  if (executionList?.value?.length > 0 && !selectedExecution.value) {
    showAlert(TYPE.WARNING, t("Common.ExecutionRequired"));
    return;
  }

  if (treeSource.value === "exec") {
    await submitExecSwitch();
  }

  if (treeSource.value === "config") {
    await submitConfigChanges();
  }

  // if (!isContentPathSet) {
  //   showAlert(TYPE.WARNING, t("Common.LoopStepWarning"));
  //   return;
  // }

  if (invalidVariables.length > 0) {
    showAlert(TYPE.WARNING, t("Common.EmptyItemKeyWarning"));
    return;
  }

  const invalidErrors = udvErrors.value.filter((err) => !err.flag);

  if (invalidErrors.length > 0) {
    const stepMessages = invalidErrors
      .map((err) =>
        t("Common.StepCheckUserDefinedVariables", {
          step: getUdvErrorStepNumber(err),
        })
      )
      .join("\n");
    showAlert(TYPE.ERROR, stepMessages);
    return;
  }
  if (
    flow?.value?.name?.length > currentCharLimit.value ||
    flow?.value?.description?.length > currentCharLimit.value
  ) {
    showAlert(
      TYPE.ERROR,
      t("Common.CharacterLimitWarning", { limit: currentCharLimit.value })
    );
    return;
  }

  if (drawerVisible.value && editStepRef.value) {
    // eslint-disable-next-line no-unused-expressions
    editStepRef.value?.updateCurrentSavedData();
    if (editStepRef.value) {
      editStepRef.value.resetConnectionAndActionChanges();
    }
  }

  if (hasPermission("FLOWS.FLOW.SAVE") && flow.value.name) {
    flow.value.steps = useAddPositionToStep(
      filterSteps(allStep.value),
      flow.value?.flowLines ?? flowLines.value
    );
    overrideIxForBackend(flow.value.steps);
    responseLoading.value = true;
    const isConditionValid = isAnyRouteHasNotFilterProp(flow.value.steps);
    const isStepValid = isAnyStepHasNotConnectorProp(flow.value.steps);
    if (!isConditionValid) {
      responseLoading.value = false;
      showAlert(TYPE.ERROR, t("Flow.ConditionIsRequired"));
      return;
    }

    const invalidFilters = findInvalidStepFilterIndex(steps.value);
    if (invalidFilters.length > 0) {
      responseLoading.value = false;
      showAlert(
        TYPE.ERROR,
        `${t("Flow.FilterIsRequired")} ${invalidFilters.join(", ")}.`
      );
      return;
    }
    if (isReportModeSelected(flow.value)) {
      responseLoading.value = false;
      showAlert(TYPE.WARNING, t("Flow.SendReport"));
      return;
    }
    if (!isStepValid) {
      responseLoading.value = false;
      showAlert(TYPE.ERROR, t("Flow.ConnectorIsRequired"));
      return;
    }

    if (isDuplicateKeys()) {
      responseLoading.value = false;
      showAlert(TYPE.WARNING, t("Flow.KeyIsAlreadyExist"));
      return;
    }

    if (isSpecialCharEntered.value) {
      responseLoading.value = false;
      showAlert(TYPE.WARNING, t("Flow.KeyIncluedSpecialChar"));
      return;
    }

    // Normalization is debounced + async, so the parent's `flow.schedule` lags the form.
    // Settle it before saving, otherwise a quick save persists the PREVIOUS schedule.
    if (cronEditorRef.value) {
      const scheduleValid = await cronEditorRef.value.flushSchedule();
      if (!scheduleValid) {
        responseLoading.value = false;
        showAlert(
          TYPE.ERROR,
          cronEditorRef.value.scheduleError || t("Flow.ScheduleWarning")
        );
        return;
      }
    }

    if (isScheduledFlow(flow.value) && !isScheduled(flow.value)) {
      responseLoading.value = false;
      showAlert(TYPE.WARNING, t("Flow.ScheduleWarning"));
      return;
    }
    if (
      flow?.value?.scheduleType === "SCHEDULED" &&
      flow?.value?.schedule?.settings?.selectedScheduleType === "ADVANCED"
    ) {
      const valid = await validateCronExpression(
        flow?.value?.schedule?.cronExpr
      );
      if (!valid) {
        responseLoading.value = false;
        showAlert(TYPE.ERROR, t("Schedule.InvalidCronSyntax"));
        return;
      }
    }
    flow.value.userDefinedVariables = formatUserDefinedVariables();
    try {
      flow.value = await addSourceAndTarget(flow.value);
      const parallelThreadBudget = await evaluateParallelThreadBudget(
        flow.value
      );
      if (currentRoute.value.params.id) {
        if (isStepNameExceedingCharLimit.value) {
          responseLoading.value = false;
          return;
        }
        if (!flow.value.timeZone) {
          // get user's local time zone
          const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          flow.value.timeZone = userTimeZone;
        }
        const response = await editFlow(flow.value);
        if (response) {
          showSaveResultAlert("updated", parallelThreadBudget);
          isVersionChanged.value = true;
          resetUnsavedState();
          if (flowDiagramRef.value) flowDiagramRef.value.resetInitialLoad();
          await navigateToSavedFlowVersion(response);
          await getSelectedFlow({ newFlow: response });
          await getConfigurationVariables();
          checkReportStatus();
        }
      } else {
        if (!flow.value.timeZone) {
          // get user's local time zone
          const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
          flow.value.timeZone = userTimeZone;
        }
        const response = await addFlow(flow.value);
        if (response) {
          showSaveResultAlert("created", parallelThreadBudget);
          isVersionChanged.value = true;
          resetUnsavedState();
          if (flowDiagramRef.value) flowDiagramRef.value.resetInitialLoad();
          await navigateToSavedFlowVersion(response);
          await getSelectedFlow({ newFlow: response });
          await getConfigurationVariables();
          checkReportStatus();
        }
      }
      responseLoading.value = false;
      resetUnsavedState();
    } catch (e) {
      responseLoading.value = false;
      showAlert(TYPE.ERROR, e.message ?? t("UnknownError"));
    }
  } else if (flow.value.name === "") {
    showAlert(TYPE.WARNING, "Please fill name");
    if (!infoVisible.value) {
      showInfo();
    }
  }
}

async function flowRevert() {
  if (flowId.value) {
    const isConfirmed = await showConfirm(
      "warning",
      "Revert Flow",
      "Are you sure revert to this version?"
    );
    if (isConfirmed) {
      responseLoading.value = true;
      const response = await revertFlow(flowId.value, flow.value.version);
      if (response) {
        await switchFlow(response.id, response.version);
        showAlert(TYPE.SUCCESS, t("Flow.RevertSuccess"));
      }
      responseLoading.value = false;
    }
  }
}

function changeDrawerData() {
  if (drawerVisible.value && selectedIndex.value !== undefined) {
    const stepList = useAddPositionToStep(
      allStep.value,
      flow.value?.flowLines ?? flowLines.value
    );
    updateSelectedStep(stepList, selectedStep.value);
    drawerVisible.value = false;
    if (selectedStep.value) {
      drawerVisible.value = true;
    }
  }
}

async function updateFlow() {
  if (
    areStepsValid.value &&
    updatedFlow.value.name &&
    hasPermission("FLOWS.FLOW.SAVE")
  ) {
    updatedFlow.value.steps = useAddPositionToStep(
      filterSteps(steps.value),
      flow.value?.flowLines ?? flowLines.value
    );
    overrideIxForBackend(updatedFlow.value.steps);
    try {
      updatedFlow.value = await addSourceAndTarget(updatedFlow.value);
      const parallelThreadBudget = await evaluateParallelThreadBudget(
        updatedFlow.value
      );
      const response = await editFlow(updatedFlow.value);
      if (response) {
        showSaveResultAlert("updated", parallelThreadBudget);
        isAnyChange.value = false;
        EventBus.isAnyChange = false;
      }
    } catch (e) {
      showAlert(TYPE.ERROR, e.message);
    }
  }
}

function filterSteps(list) {
  const stepList = JSON.parse(JSON.stringify(list));
  stepList.forEach((step, index) => {
    delete step.flow;
    if (typeof step.id === "string" && !checkIfValidUUID(step.id)) {
      step.id = undefined;
    }
    if (step.type && step.type !== "LOOP" && step.type !== "LOOP_END") {
      step.name = "router";
      // Also add a safety check for routes existence
      if (step.routes && Array.isArray(step.routes)) {
        step.routes.forEach((route) => {
          delete route.flow;
          route.steps = filterSteps(route.steps);
        });
      }
    }

    stepList.splice(index, 1, step);
  });
  return stripUdvValueOnlyRows(stepList);
}

function checkIfValidUUID(str) {
  const regexExp =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-5][0-9a-f]{3}-[089ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

  return regexExp.test(str);
}

function checkStepsValid() {
  let valid = true;
  steps.value.forEach((step) => {
    if (!step.type || step.type === "LOOP") {
      // Connection-optional steps have no connection but carry a connectorSpecId.
      if ((!step.connection && !step.connectorSpecId) || !step.actions) {
        valid = false;
      }
    }
  });
  return valid;
}

function updateSimulating(simulating) {
  stepSimulating.value = simulating;
}

async function handleSimulationUpdateOutput() {
  await updateEditFlow(false, true);
  simulationDataRefreshKey.value++;
}

function updatePopUpOpen(isOpen) {
  popUpOpen.value = isOpen;
}

async function runFlow(name) {
  if (flow.value.active && !isAnyChange.value) {
    stepSimulating.value = true;
    if (hasPermission("FLOWS.LIST.RUN") && flowId.value) {
      flowName.value = name;
      outputLogs.value = [];
      if (flowRunning.value && client) {
        runFlowDialog.value = true;
      } else {
        let parallelThreadBudget;
        try {
          parallelThreadBudget = await evaluateParallelThreadBudget(
            getCurrentFlowForParallelThreadBudget()
          );
        } catch (error) {
          stepSimulating.value = false;
          showAlert(TYPE.ERROR, error?.message ?? t("Common.UnknownError"));
          return;
        }
        if (parallelThreadBudget.exceeded) {
          stepSimulating.value = false;
          showParallelThreadBudgetWarning(parallelThreadBudget);
          return;
        }

        startFlow(flowId.value, version.value)
          .then((response) => {
            runFlowDialog.value = true;
            readFlowProcess();
            activityId.value = response;
          })
          .catch(() => {
            showAlert(TYPE.ERROR, "An error occurred while starting the flow.");
          });
      }
    }
  } else if (!flow.value.active) {
    showAlert(TYPE.ERROR, t("Flow.InactiveFlow"));
  } else if (isAnyChange.value) {
    showAlert(TYPE.WARNING, t("Flow.UnsavedChanges"));
  }
}

function readFlowProcess() {
  if (client) {
    outputLogs.value = [];
    client.disconnect();
    client = undefined;
  }
  if (flow.value.scheduleType !== "SCHEDULED") {
    stepSimulating.value = true;
  }
  const { checkIsRunActivityFromSocket } = useActivity();
  connectWebsocket().then((stompClient) => {
    stompClient.debug = (f) => f;
    client = stompClient;
    stompClient.connect({}, async () => {
      stompClient.subscribe(`/flow/${flowId.value}/process`, async (val) => {
        if (flow.value.scheduleType === "SCHEDULED") {
          runFlowDialog.value = true;
          stepSimulating.value = true;
        }
        outputLogs.value.push(val.body);
      });
      stepSimulating.value = await checkIsRunActivityFromSocket(
        stompClient,
        activityId.value,
        undefined,
        updateActivityStatus
      );
    });
  });
  processLogs.value = outputLogs.value;
}

function updateActivityStatus(activityStatus) {
  flow.value.currentActivityStatus = activityStatus;
}

async function downloadLogsAsText(flowVal) {
  if (!activityId.value) {
    showAlert(TYPE.WARNING, t("Flow.ProcessLogDownloadError"));
    return;
  }
  const response = await getFlowLogZipById(activityId.value);
  const blob = new Blob([response], { type: "application/zip" });
  const link = document.createElement("a");
  link.setAttribute("download", `${flowVal.name}-flow-logs.zip`);
  link.href = URL.createObjectURL(blob);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(link.href);
}

function expressionDrawerStatus(value) {
  expressionDrawer.value = value;
}

let resizeStartX = 0;
let resizeStartWidth = 0;

function getActiveResizeBinding(): {
  widthRef: typeof editStepWidthPx;
  el: HTMLElement | null;
  min: number;
  max: number;
  prefKey: string;
} | null {
  if (drawerVisible.value && !conditionVisible.value && !infoVisible.value) {
    return {
      widthRef: editStepWidthPx,
      el: editStepBoxRef.value,
      min: EDIT_STEP_BASE_MIN_WIDTH,
      max: getDrawerBaseMaxWidth(EDIT_STEP_BASE_MIN_WIDTH),
      prefKey: "editStepBoxWidthPx",
    };
  }
  if (infoVisible.value && !drawerVisible.value) {
    return {
      widthRef: editStepWidthPx,
      el: infoBoxRef.value,
      min: EDIT_STEP_BASE_MIN_WIDTH,
      max: getDrawerBaseMaxWidth(EDIT_STEP_BASE_MIN_WIDTH),
      prefKey: "editStepBoxWidthPx",
    };
  }
  if (conditionVisible.value) {
    return {
      widthRef: conditionWidthPx,
      el: conditionBoxRef.value,
      min: CONDITION_BASE_MIN_WIDTH,
      max: getDrawerBaseMaxWidth(CONDITION_BASE_MIN_WIDTH),
      prefKey: "conditionBoxWidthPx",
    };
  }
  if (routerVisible.value) {
    return {
      widthRef: routerWidthPx,
      el: routerBoxRef.value,
      min: ROUTER_BASE_MIN_WIDTH,
      max: getDrawerBaseMaxWidth(ROUTER_BASE_MIN_WIDTH),
      prefKey: "routerBoxWidthPx",
    };
  }
  if (userVariableVisible.value) {
    return {
      widthRef: editStepWidthPx,
      el: userVarsBoxRef.value,
      min: EDIT_STEP_BASE_MIN_WIDTH,
      max: getDrawerBaseMaxWidth(EDIT_STEP_BASE_MIN_WIDTH),
      prefKey: "editStepBoxWidthPx",
    };
  }
  if (wizardDrawerVisible.value) {
    return {
      widthRef: wizardWidthPx,
      el: wizardBoxRef.value,
      min: WIZARD_BASE_MIN_WIDTH,
      max: getWizardBaseMaxWidth(),
      prefKey: "wizardBoxWidthPx",
    };
  }
  return null;
}

const capture = { el: null as HTMLElement | null, id: 0 as number };
let resizeWidthRef: typeof editStepWidthPx | null = null;
let resizePrefKey = "editStepBoxWidthPx";

function startResize(e: PointerEvent) {
  const active = getActiveResizeBinding();
  if (!active?.el) return;

  e.preventDefault();

  // use currentTarget (the handle), not target (might be child)
  capture.el = e.currentTarget as HTMLElement | null;
  capture.id = e.pointerId;
  const handle = e.currentTarget as HTMLElement | null;
  if (handle && typeof handle.setPointerCapture === "function") {
    handle.setPointerCapture(e.pointerId);
  }

  isResizing.value = true;
  resizeStartX = e.clientX;
  resizeWidthRef = active.widthRef;
  resizePrefKey = active.prefKey;

  const rect = active.el.getBoundingClientRect();
  let activeReservePx = functionDrawerReservePx.value;
  if (active.prefKey === "wizardBoxWidthPx") {
    activeReservePx = wizardHistoryVisible.value
      ? WIZARD_HISTORY_DRAWER_WIDTH
      : 0;
  }
  resizeStartWidth = clamp(
    rect.width - activeReservePx,
    active.min,
    active.max
  );
  active.widthRef.value = Math.round(resizeStartWidth);

  document.documentElement.style.cursor = "ew-resize";
  document.body.style.userSelect = "none";

  window.addEventListener("pointermove", onResizeMove);
  window.addEventListener("pointerup", onResizeEnd, { once: true });
  window.addEventListener("pointercancel", onResizeEnd, { once: true });
  window.addEventListener("blur", onResizeEnd, { once: true });
}

function onResizeMove(e: PointerEvent) {
  if (!isResizing.value) return;
  const active = getActiveResizeBinding();
  if (!active) return;

  const dx = e.clientX - resizeStartX;
  const nextBase = clamp(resizeStartWidth + -dx, active.min, active.max);
  active.widthRef.value = Math.round(nextBase);
}

function onResizeEnd() {
  if (capture.el && typeof capture.el.releasePointerCapture === "function") {
    capture.el.releasePointerCapture(capture.id);
  }
  capture.el = null;
  capture.id = 0;

  isResizing.value = false;
  document.documentElement.style.cursor = "";
  document.body.style.userSelect = "";
  window.removeEventListener("pointermove", onResizeMove);
  if (resizeWidthRef) {
    saveWidthPref(resizePrefKey, resizeWidthRef.value);
  }
  resizeWidthRef = null;
  resizePrefKey = "editStepBoxWidthPx";
}

function clamp(v: number, min: number, max: number) {
  return Math.min(Math.max(v, min), max);
}

function getNumberPref(key: string, fallback: number): number {
  const raw = getPreferenceValue(key);
  const n = typeof raw === "string" ? parseInt(raw, 10) : Number(raw);
  return Number.isFinite(n) && n > 0 ? n : fallback;
}

function saveWidthPref(key: string, px: number) {
  updateSinglePreference(key, String(Math.round(px)));
}

function getFlowExecutionType(): string | null {
  const typeFromFlow =
    flow.value?.execution?.type ?? flow.value?.execution?.executionType;
  if (typeFromFlow) return String(typeFromFlow).toUpperCase();

  const node = findInTree(tree.value, (n) => n.label === "flow.execution");
  return node?.inputValue ? String(node.inputValue).toUpperCase() : null;
}

function findInTree<T extends { children?: T[] }>(
  nodes: T[] | null | undefined,
  predicate: (n: T) => boolean
): T | null {
  if (!Array.isArray(nodes) || nodes.length === 0) return null;
  let result: T | null = null;
  nodes.some((n) => {
    if (predicate(n)) {
      result = n;
      return true; // stop .some()
    }
    const found = findInTree(n.children, predicate);
    if (found) {
      result = found;
      return true; // stop .some()
    }
    return false;
  });
  return result;
}

function stopRunningFlow() {
  if (hasPermission("FLOWS.LIST.STOP")) {
    if (client) {
      client.disconnect();
      client = undefined;
    }
    if (getFlowExecutionType() === "NATIVE") {
      showAlert(TYPE.WARNING, t("Flow.StoppingNativeFlowError"));
      stepSimulating.value = false;
      updateEditFlow(false);
      closeFlowDialog();
    } else {
      stopFlow(activityId.value)
        .then(() => {
          flowStatus.value = "STOPPED";
          flow.value.flowStatusType = "STOPPED";
          stepSimulating.value = false;
          updateEditFlow(false);
        })
        .catch(() => {
          showAlert(TYPE.ERROR, "An error occurred while stopping the flow.");
        })
        .finally(() => {
          flowStatus.value = "STOPPED";
          closeFlowDialog();
        });
    }
  }
}

function closeFlowDialog() {
  runFlowDialog.value = false;
}

async function switchFlow(id, versionNumber) {
  isVersionChanged.value = true;

  const flowData = await getFlow(id, String(versionNumber));
  const isNewUi = !!flowData?.newUi;

  const targetRouteName = isNewUi ? "editFlowsRouteNew" : "editFlows";

  await router.push({
    name: targetRouteName,
    params: { id, version: versionNumber },
  });

  if (isNewUi) {
    if (flowDiagramRef.value) flowDiagramRef.value.resetInitialLoad();
    await getSelectedFlow();
    checkReportStatus();
    setActiveOne();
  }
}

function updateResponseLoading(loading) {
  responseLoading.value = loading;
}

function handleEmails(value) {
  const emails = value.split(";").map((email) => email.trim());
  emails.map((email) => validateEmail(email));
}

function validateEmail(value) {
  if (/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value)) {
    invalidEmail.value = "";
    return true;
  }
  invalidEmail.value = t("Auth.EmailVal");
  return false;
}

function handleInputChange(data) {
  updatedConfigurations.value[data.label] = {
    ...updatedConfigurations.value[data.inputValue],
    ...data,
  };
}

function handleInputValueChange(data, value) {
  data.inputValue = value;
  if (treeSource.value === "exec") {
    pendingData.value = {
      deleted: false,
      key: data.label,
      level: data.level,
      description: data.description,
      value,
      type: data.type,
      children: [],
      ownerId: data.id,
      enumerationValues: data.enumerationValues,
    };
  }
  if (treeSource.value === "config") {
    handleInputChange(data);
  }
}
function isTextLong(description) {
  return description && description.length > 20;
}
function isReportModeSelected(flowToBeUpdated) {
  return (
    flowToBeUpdated.sendFlowReport &&
    !flowToBeUpdated.onError &&
    !flowToBeUpdated.onSuccess
  );
}

function isScheduledFlow(flowToBeUpdated) {
  if (flowToBeUpdated.scheduleType === "SCHEDULED") {
    return true;
  }
  return false;
}

function isScheduled(flowToBeUpdated) {
  const { schedule } = flowToBeUpdated;
  const isAdvanced = schedule?.settings?.selectedScheduleType === "ADVANCED";
  return (
    (isAdvanced || schedule?.scheduleTime !== null) &&
    schedule?.cronExpr !== "UNDEFINED_CRON" &&
    schedule?.cronExpr !== ""
  );
}

async function publishFlow() {
  if (hasPermission("FLOWS.FLOW.SAVE")) {
    if (flow.value.flowStatusType === "DRAFT") {
      flow.value.flowStatusType = "PUBLISHED";
      flow.value.steps = useAddPositionToStep(
        filterSteps(allStep.value),
        flow.value?.flowLines ?? flowLines.value
      );
      overrideIxForBackend(flow.value.steps);
      const parallelThreadBudget = await evaluateParallelThreadBudget(
        flow.value
      );
      const response = await editFlow(flow.value);
      if (response) {
        showSaveResultAlert("published", parallelThreadBudget);
        isVersionChanged.value = true;
        resetUnsavedState();
        if (flowDiagramRef.value) flowDiagramRef.value.resetInitialLoad();
        await navigateToSavedFlowVersion(response);
        await getSelectedFlow({ newFlow: response });
        checkReportStatus();
      }
    }
  }
}

function cloneStep(step) {
  flushCurrentEditStepState();
  clonedStep.value = resolveFreshStep(step);
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (pageOpen.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: componentKey.value,
        id: "edit-flow",
        class: "full-size",
        style: _normalizeStyle({ backgroundColor: backgroundColor.value }),
        onClick: closeContextMenu
      }, [
        _createElementVNode("div", _hoisted_1, [
          (activeTab.value === 1)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                id: "edit-flow-content",
                ref_key: "editFlowContent",
                ref: editFlowContent,
                class: _normalizeClass(["d-flex width-100 height-100", { 'wizard-review-active': wizardReviewActive.value }])
              }, [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", {
                    onClick: handleClickOutside,
                    class: "width-100",
                    style: {"flex":"1","min-height":"0","position":"relative","isolation":"isolate"}
                  }, [
                    (!pageLoading.value && !wizardReviewActive.value)
                      ? (_openBlock(), _createBlock(FlowDiagram, {
                          key: 0,
                          ref_key: "flowDiagramRef",
                          ref: flowDiagramRef,
                          steps: allStep.value,
                          flow: flow.value,
                          flowLines: flowLines.value,
                          "selected-step": selectedStep.value,
                          "selected-index": selectedIndex.value,
                          "list-index": '',
                          "cloned-step": clonedStep.value,
                          newEdge: newEdge.value,
                          nodesDraggable: true,
                          backgroundColor: backgroundColor.value,
                          startStepPosition: startStepPosition.value,
                          drawerVisible: drawerVisible.value || routerVisible.value || loopVisible.value,
                          onOpenDrawer: openDrawer,
                          onOpenRouter: openRouterSettings,
                          onOpenLoop: openLoopSettings,
                          onCloseDrawer: closeDrawer,
                          onCloseRouter: closeRouterSettings,
                          onUpdate: updateStepList,
                          onUpdateChangedList: updateChangedList,
                          onShowCondition: showCondition,
                          onOpenDelay: openDelay,
                          onCloneStep: cloneStep,
                          onOpenOutput: openOutput,
                          onUpdateStepPositions: _cache[0] || (_cache[0] = 
                (stepList, buttonClicked) =>
                  organizeSteps(stepList, buttonClicked)
              ),
                          onOutputListChanged: outputListChanged,
                          showOrganizeSteps: true,
                          onFilterRemoved: onFilterRemoved,
                          onInvalidLoopChange: onInvalidLoopChange
                        }, null, 8, ["steps", "flow", "flowLines", "selected-step", "selected-index", "cloned-step", "newEdge", "backgroundColor", "startStepPosition", "drawerVisible"]))
                      : _createCommentVNode("", true),
                    (wizardReviewActive.value)
                      ? (_openBlock(), _createBlock(FlowPreviewOverlay, {
                          key: 1,
                          "flow-spec": wizardPreviewFlowSpec.value,
                          "approval-intent": flowId.value ? 'update' : 'create',
                          submitting: wizardPreviewSubmitting.value,
                          style: {"position":"absolute","inset":"0","z-index":"20"},
                          onApprove: handleWizardPreviewApprove,
                          onReject: handleWizardPreviewReject,
                          onFeedback: handleWizardPreviewFeedback
                        }, null, 8, ["flow-spec", "approval-intent", "submitting"]))
                      : _createCommentVNode("", true)
                  ]),
                  _hoisted_3,
                  (combinedConnections.value.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        (!pageLoading.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                              _createTextVNode(_toDisplayString(_unref(hasPermission)("CONNECTIONS.LIST.CREATE")
                  ? _unref(t)("Flow.ConnectionWarning")
                  : _unref(t)("Flow.ConnectionWarning2")) + " ", 1),
                              (_unref(hasPermission)('CONNECTIONS.LIST.CREATE'))
                                ? (_openBlock(), _createElementBlock("button", {
                                    key: 0,
                                    class: "btn btn-oneTeg margin-top-10",
                                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/connections/create')))
                                  }, _toDisplayString(_unref(t)("Common.Create")), 1))
                                : _createCommentVNode("", true)
                            ]))
                          : _createCommentVNode("", true)
                      ]))
                    : _createCommentVNode("", true)
                ]),
                (drawerVisible.value && !conditionVisible.value && !infoVisible.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      id: "edit-step-box",
                      ref_key: "editStepBoxRef",
                      ref: editStepBoxRef,
                      class: _normalizeClass(["background-fb z-index-15", [
            {
              'drawer-visible': drawerVisible.value,
              'function-drawer-open': functionsVisible.value && !expressionDrawer.value,
              'function-expression-drawer-open':
                functionsVisible.value && expressionDrawer.value,
              'function-drawer-close': !functionsVisible.value,
            },
          ]]),
                      style: _normalizeStyle({
            width: currentEditStepWidthPx.value + 'px',
            minWidth: minEditStepWidth.value + 'px',
            maxWidth: '1500px',
          })
                    }, [
                      _createElementVNode("div", {
                        id: "resize",
                        class: "resize-item",
                        onPointerdown: startResize
                      }, null, 32),
                      (_openBlock(), _createBlock(_unref(EditStep), {
                        class: _normalizeClass(`oneteg-drawer-${getSizeByValue(editStepSize.value)}`),
                        connections: combinedConnections.value,
                        step: selectedStep.value,
                        size: currentEditStepWidthPx.value,
                        key: editStepKey.value,
                        "step-idx": selectedIndex.value,
                        "step-simulating": stepSimulating.value,
                        popUpOpen: popUpOpen.value,
                        outputList: outputList.value,
                        metaoutputList: metaoutputList.value,
                        userDefinedVariables: userDefinedVariables.value,
                        "system-variables": systemVariables.value,
                        visible: drawerVisible.value,
                        "is-step-in-router": isStepInRouter.value,
                        flow: flow.value,
                        "is-step-changed": isAnyChange.value,
                        "id-suffix": 0,
                        expressions: expressions.value,
                        onExpressionDrawer: expressionDrawerStatus,
                        onStepChange: updateStep,
                        onUpdateSimulate: _cache[2] || (_cache[2] = ($event: any) => (updateSimulating($event))),
                        onUpdatePopUpOpen: _cache[3] || (_cache[3] = ($event: any) => (updatePopUpOpen($event))),
                        onChange: _cache[4] || (_cache[4] = ($event: any) => (onStepChange(selectedIndex.value, $event))),
                        onClose: _cache[5] || (_cache[5] = ($event: any) => (removeStep(selectedIndex.value, selectedStep.value))),
                        onUpdate: updateFlow,
                        onCloseDrawer: closeDrawer,
                        onSetLoading: setLoading,
                        onChangeFunctionVisible: changeFunctionsVisible,
                        onUpdateOutput: handleSimulationUpdateOutput,
                        onUpdateCurrentActivityStatus: updateActivityStatus,
                        onSimulateForSpec: _cache[6] || (_cache[6] = (opts) => simulateSelectedStep(false, opts)),
                        onSaveAfterSpec: onSaveAfterSpec,
                        ref_key: "editStepRef",
                        ref: editStepRef,
                        onUdvError: handleUdvError,
                        onAnalyzeWithWizard: handleAnalyzeWithWizard,
                        "wizard-enabled": aiWizardEnabled.value,
                        "simulation-data-refresh-key": simulationDataRefreshKey.value
                      }, null, 8, ["class", "connections", "step", "size", "step-idx", "step-simulating", "popUpOpen", "outputList", "metaoutputList", "userDefinedVariables", "system-variables", "visible", "is-step-in-router", "flow", "is-step-changed", "expressions", "wizard-enabled", "simulation-data-refresh-key"]))
                    ], 6))
                  : _createCommentVNode("", true),
                (infoVisible.value && !drawerVisible.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 1,
                      id: "flow-info-box",
                      ref_key: "infoBoxRef",
                      ref: infoBoxRef,
                      class: _normalizeClass(["background-fb z-index-15", { 'drawer-visible': infoVisible.value && !drawerVisible.value }]),
                      style: _normalizeStyle({
            width: currentEditStepWidthPx.value + 'px',
            minWidth: minEditStepWidth.value + 'px',
            maxWidth: '1500px',
          })
                    }, [
                      _createElementVNode("div", {
                        id: "resize-info",
                        class: "resize-item",
                        onPointerdown: startResize
                      }, null, 32),
                      _createElementVNode("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)("Flow.FlowDetails")), 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-link",
                            id: "close-info",
                            onClick: showInfo
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "times" })
                          ])
                        ]),
                        _createVNode(_unref(ElDivider), { style: {"margin":"0"} }),
                        _createElementVNode("div", _hoisted_8, [
                          (flowId.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                _createElementVNode("strong", null, _toDisplayString(_unref(t)("Flow.FlowID")), 1),
                                _createElementVNode("span", null, _toDisplayString(flowId.value), 1)
                              ]))
                            : _createCommentVNode("", true),
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Name")), 1),
                            _hoisted_11,
                            _createVNode(_unref(ElInput), {
                              onInput: onFlowChange,
                              modelValue: flow.value.name,
                              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((flow.value.name) = $event)),
                              ref_key: "nameInputField",
                              ref: nameInputField,
                              size: "small",
                              "input-style": 
                    flow.value.name !== undefined && flow.value.name !== ''
                      ? {}
                      : { 'border-color': 'red' }
                  ,
                              placeholder: _unref(t)('Common.Name')
                            }, null, 8, ["modelValue", "input-style", "placeholder"]),
                            (isNameNearLimit.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                  _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(t)("Common.CharacterLimitWarning", {
                      limit: currentCharLimit.value,
                    })), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_14, [
                            _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Description")), 1),
                            _hoisted_15,
                            _createVNode(_unref(ElInput), {
                              onInput: onFlowChange,
                              modelValue: flow.value.description,
                              "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((flow.value.description) = $event)),
                              size: "small",
                              placeholder: _unref(t)('Common.Description')
                            }, null, 8, ["modelValue", "placeholder"]),
                            (isDescriptionNearLimit.value)
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  _createElementVNode("span", _hoisted_17, _toDisplayString(_unref(t)("Common.CharacterLimitWarning", {
                      limit: currentCharLimit.value,
                    })), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_18, [
                            _createElementVNode("div", _hoisted_19, [
                              _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Active")), 1),
                              _createVNode(_unref(ElSwitch), {
                                onChange: onFlowChange,
                                "active-color": "#5022a6",
                                id: "flow-active",
                                class: "element-switch-oneteg",
                                width: 48,
                                modelValue: flow.value.active,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((flow.value.active) = $event))
                              }, null, 8, ["modelValue"])
                            ]),
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("strong", null, _toDisplayString(_unref(t)("Flow.ContinueOnFail")), 1),
                              _createVNode(_unref(ElSwitch), {
                                onChange: onFlowChange,
                                "active-color": "#5022a6",
                                id: "flow-continue-on-fail",
                                class: "element-switch-oneteg align-items-center",
                                width: 48,
                                modelValue: flow.value.continueOnFailure,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((flow.value.continueOnFailure) = $event))
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          (aiWizardEnabled.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                                _createElementVNode("div", _hoisted_22, [
                                  _createElementVNode("strong", null, _toDisplayString(_unref(t)("Flow.SkillGenerationForFlow")), 1),
                                  _createVNode(_unref(ElTooltip), {
                                    content: _unref(t)('Flow.SkillGenerationForFlowTooltip'),
                                    placement: "top"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_font_awesome_icon, {
                                        icon: "info-circle",
                                        style: {"cursor":"default","font-size":"12px","color":"#909399"}
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["content"])
                                ]),
                                _createVNode(_unref(ElSwitch), {
                                  "active-color": "#5022a6",
                                  id: "flow-skill-generation",
                                  class: "element-switch-oneteg",
                                  width: 48,
                                  modelValue: skillGenerationEnabledModel.value,
                                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((skillGenerationEnabledModel).value = $event))
                                }, null, 8, ["modelValue"])
                              ]))
                            : _createCommentVNode("", true),
                          (flow.value.createdAt || flow.value.createdBy)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                                (flow.value.createdAt)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                      _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.CreationTime")), 1),
                                      _createTextVNode(" " + _toDisplayString(_unref(convertDate)(createdAtDate.value)), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (flow.value.createdBy)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                      _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.CreatedBy")), 1),
                                      _createTextVNode(" " + _toDisplayString(createdByName.value?.fullName), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (flow.value.updatedAt || flow.value.modifiedBy)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                                (flow.value.updatedAt)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                      _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.UpdatedAt")), 1),
                                      _createTextVNode(" " + _toDisplayString(_unref(convertDate)(flow.value.updatedAt)), 1)
                                    ]))
                                  : _createCommentVNode("", true),
                                (flow.value.modifiedBy)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_28, [
                                      _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.UpdatedBy")), 1),
                                      _createTextVNode(" " + _toDisplayString(updatedByName.value), 1)
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (flow.value.modifiedBy)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                _createElementVNode("strong", null, _toDisplayString(_unref(t)("Flow.Version")), 1),
                                _createTextVNode(" " + _toDisplayString(flow.value.version), 1)
                              ]))
                            : _createCommentVNode("", true),
                          (
                  !pageLoading.value &&
                  executionList.value?.length === 0 &&
                  tenantDefaultExecution.value?.length > 0
                )
                            ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                                _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Execution")), 1),
                                _createElementVNode("span", _hoisted_31, [
                                  _createElementVNode("img", {
                                    class: "logo-24",
                                    src: `${_unref(ASSETS_BASE_URL)}/${
                      tenantDefaultExecution.value[0].execution?.type
                    }${_unref(getResolution)(false)}.png`,
                                    alt: "logo",
                                    style: {"margin-right":"8px"}
                                  }, null, 8, _hoisted_32),
                                  _createTextVNode(" " + _toDisplayString(`${tenantDefaultExecution.value[0].execution?.name} (${_unref(t)(
                      "Common.TenantDefault"
                    )})`), 1)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (!pageLoading.value && executionList.value?.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Execution")), 1),
                                _createVNode(_unref(ElSelect), {
                                  modelValue: selectedExecution.value,
                                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((selectedExecution).value = $event)),
                                  size: "small",
                                  placeholder: "Select Execution",
                                  style: {"margin-bottom":"10px"},
                                  clearable: false,
                                  disabled: pageLoading.value,
                                  onChange: handleExecutionChange
                                }, {
                                  prefix: _withCtx(() => [
                                    _createElementVNode("span", _hoisted_34, [
                                      (selectedExecution.value)
                                        ? (_openBlock(), _createElementBlock("img", {
                                            key: 0,
                                            class: "logo-24",
                                            src: getLogoSrc(selectedExecution.value),
                                            alt: "logo",
                                            style: {"margin-right":"8px"}
                                          }, null, 8, _hoisted_35))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(executionList.value, (execution) => {
                                      return (_openBlock(), _createBlock(_unref(ElOption), {
                                        key: execution.id,
                                        label: 
                      execution.id === defaultExecution.value
                        ? `${execution.name} (${_unref(t)(
                            'Common.OrganizationDefault'
                          )})`
                        : execution.name
                    ,
                                        value: execution.id
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", _hoisted_36, [
                                            _createElementVNode("img", {
                                              class: "logo-24",
                                              src: `${_unref(ASSETS_BASE_URL)}/${
                          execution.type
                        }${_unref(getResolution)(false)}.png`,
                                              alt: "logo",
                                              style: {"margin-right":"8px"}
                                            }, null, 8, _hoisted_37),
                                            _createTextVNode(" " + _toDisplayString(execution.id === defaultExecution.value
                          ? `${execution.name} (${_unref(t)(
                              "Common.OrganizationDefault"
                            )})`
                          : execution.name), 1)
                                          ])
                                        ]),
                                        _: 2
                                      }, 1032, ["label", "value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue", "disabled"])
                              ]))
                            : _createCommentVNode("", true),
                          (flow.value.active && flow.value.scheduleType && !pageLoading.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                _createElementVNode("strong", null, _toDisplayString(_unref(t)("Schedule.Schedule")), 1),
                                _createVNode(_unref(CronEditor), {
                                  ref_key: "cronEditorRef",
                                  ref: cronEditorRef,
                                  schedule: flow.value.schedule,
                                  "schedule-type": flow.value.scheduleType,
                                  "time-zone": flow.value.timeZone,
                                  "flow-id": flow.value.id,
                                  "flow-version": flow.value.version,
                                  onUpdate: updateCronExpr,
                                  onScheduleTypeChange: handleScheduleTypeChange,
                                  onUpdateDrawer: setEditorVisible,
                                  onStepChange: onFlowChange
                                }, null, 8, ["schedule", "schedule-type", "time-zone", "flow-id", "flow-version"])
                              ]))
                            : _createCommentVNode("", true),
                          (flow.value.schedule && nextRunTime.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_39, [
                                (flow.value.schedule && nextRunTime.value)
                                  ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                                      key: 0,
                                      effect: "custom",
                                      placement: "auto",
                                      content: _unref(t)('Schedule.NextRunTimeTooltip')
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", null, [
                                          _createElementVNode("span", _hoisted_40, _toDisplayString(_unref(t)("Schedule.NextFireTime")), 1),
                                          _hoisted_41,
                                          _createTextVNode(" " + _toDisplayString(_unref(convertDate)(nextRunTime.value)), 1)
                                        ])
                                      ]),
                                      _: 1
                                    }, 8, ["content"]))
                                  : _createCommentVNode("", true)
                              ]))
                            : _createCommentVNode("", true),
                          (flow.value.active && isScheduledFlow(flow.value))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                _createElementVNode("div", _hoisted_43, [
                                  _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.TimeZone")), 1)
                                ]),
                                _createVNode(_unref(ElSelect), {
                                  onChange: handleTimezoneChange,
                                  modelValue: selectedOffset.value,
                                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((selectedOffset).value = $event)),
                                  id: "connection-connector-select",
                                  filterable: "",
                                  size: "small"
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(timezoneOffsets), (offset, index) => {
                                      return (_openBlock(), _createBlock(_unref(ElOption), {
                                        key: index,
                                        value: offset.offset
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", _hoisted_44, _toDisplayString(offset.offset), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]))
                            : _createCommentVNode("", true),
                          (flow.value.flowStatusType)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.Status")), 1),
                                _createElementVNode("div", _hoisted_46, [
                                  _createVNode(_unref(ElTag), {
                                    type: _unref(statusColor)(flow.value.flowStatusType)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(flow.value.flowStatusType), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["type"]),
                                  (flow.value.flowStatusType === 'DRAFT')
                                    ? (_openBlock(), _createBlock(_unref(ElButton), {
                                        key: 0,
                                        class: "margin-left-20",
                                        style: {"text-decoration":"none"},
                                        size: "small",
                                        type: "button",
                                        onClick: _cache[14] || (_cache[14] = ($event: any) => (publishFlow()))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_unref(t)("Flow.PublishFlow")), 1)
                                        ]),
                                        _: 1
                                      }))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          (showAIReportSection.value)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 11 }, [
                                _createVNode(_unref(ElDivider), { style: {"margin":"10px 0","border-color":"#e0e0e0"} }),
                                _createElementVNode("div", _hoisted_47, [
                                  _createElementVNode("strong", null, _toDisplayString(_unref(t)("Flow.AIReportGeneration")), 1),
                                  _createElementVNode("div", _hoisted_48, [
                                    (!reportExists.value)
                                      ? (_openBlock(), _createBlock(_unref(ElButton), {
                                          key: 0,
                                          size: "small",
                                          type: "button",
                                          loading: isGenerating.value,
                                          disabled: responseLoading.value,
                                          onClick: onGenerateReport
                                        }, {
                                          default: _withCtx(() => [
                                            (!isGenerating.value)
                                              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                                  key: 0,
                                                  icon: "magic",
                                                  class: "margin-right-5"
                                                }))
                                              : _createCommentVNode("", true),
                                            _createTextVNode(" " + _toDisplayString(isGenerating.value
                          ? _unref(t)("Flow.Generating")
                          : _unref(t)("Flow.GenerateReport")), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["loading", "disabled"]))
                                      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                                          _createVNode(_unref(ElTooltip), {
                                            content: 
                          isReportUpToDate.value
                            ? _unref(t)('Flow.ReportAlreadyUpToDate')
                            : ''
                        ,
                                            disabled: !isReportUpToDate.value,
                                            placement: "top"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("span", null, [
                                                _createVNode(_unref(ElButton), {
                                                  size: "small",
                                                  type: "button",
                                                  loading: isGenerating.value,
                                                  disabled: responseLoading.value || isReportUpToDate.value,
                                                  onClick: onUpdateReport
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_font_awesome_icon, {
                                                      icon: isGenerating.value ? 'spinner' : 'sync',
                                                      spin: isGenerating.value,
                                                      class: "margin-right-5"
                                                    }, null, 8, ["icon", "spin"]),
                                                    _createTextVNode(" " + _toDisplayString(isGenerating.value
                                ? _unref(t)("Flow.Updating")
                                : _unref(t)("Flow.Update")), 1)
                                                  ]),
                                                  _: 1
                                                }, 8, ["loading", "disabled"])
                                              ])
                                            ]),
                                            _: 1
                                          }, 8, ["content", "disabled"]),
                                          _createVNode(_unref(ElSelect), {
                                            modelValue: selectedReportFormat.value,
                                            "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((selectedReportFormat).value = $event)),
                                            size: "small",
                                            placeholder: _unref(t)('Flow.ReportFormatPlaceholder'),
                                            style: {"width":"85px"}
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_unref(ElOption), {
                                                label: "PDF",
                                                value: "pdf"
                                              }),
                                              _createVNode(_unref(ElOption), {
                                                label: "DOCX",
                                                value: "docx"
                                              }),
                                              _createVNode(_unref(ElOption), {
                                                label: "MD",
                                                value: "md"
                                              }),
                                              _createVNode(_unref(ElOption), {
                                                label: "JSON",
                                                value: "json"
                                              })
                                            ]),
                                            _: 1
                                          }, 8, ["modelValue", "placeholder"]),
                                          _createVNode(_unref(ElTooltip), {
                                            content: 
                          selectedReportFormat.value === 'pdf' && !isPdfReady.value
                            ? _unref(t)('Flow.PdfStillRendering')
                            : _unref(t)('Flow.Download')
                        ,
                                            placement: "top"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("span", null, [
                                                _createVNode(_unref(ElButton), {
                                                  size: "small",
                                                  type: "button",
                                                  loading: isRetrieving.value,
                                                  disabled: 
                              isRetrieving.value ||
                              (selectedReportFormat.value === 'pdf' && !isPdfReady.value)
                            ,
                                                  onClick: onRetrieveReport
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_font_awesome_icon, {
                                                      style: {"color":"#606266"},
                                                      icon: _unref(faDownload)
                                                    }, null, 8, ["icon"])
                                                  ]),
                                                  _: 1
                                                }, 8, ["loading", "disabled"])
                                              ])
                                            ]),
                                            _: 1
                                          }, 8, ["content"])
                                        ], 64))
                                  ])
                                ])
                              ], 64))
                            : _createCommentVNode("", true),
                          (aiSkillGeneratorEnabled.value && flowId.value && flow.value.version != null)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 12 }, [
                                _createVNode(_unref(ElDivider), { style: {"margin":"16px 0","border-color":"#e0e0e0"} }),
                                _createElementVNode("div", _hoisted_49, [
                                  _createElementVNode("div", _hoisted_50, [
                                    _createElementVNode("strong", null, _toDisplayString(_unref(t)("Flow.AISkillGeneration")), 1),
                                    _createVNode(_unref(ElTooltip), {
                                      effect: "custom",
                                      placement: "top"
                                    }, {
                                      content: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_51, _toDisplayString(_unref(t)("Flow.AISkillGenerationTooltip")), 1)
                                      ]),
                                      default: _withCtx(() => [
                                        _createVNode(_component_font_awesome_icon, {
                                          icon: "info-circle",
                                          class: "color-dark-gray margin-left-5",
                                          style: {"cursor":"default","font-size":"13px"}
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  (isSkillUpToDate.value)
                                    ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                                        key: 0,
                                        content: _unref(t)('Flow.SkillAlreadyUpToDate'),
                                        placement: "top"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("span", null, [
                                            _createVNode(_unref(ElButton), {
                                              size: "small",
                                              type: "button",
                                              disabled: true
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_font_awesome_icon, {
                                                  icon: "check",
                                                  class: "margin-right-5 color-green"
                                                }),
                                                _createTextVNode(" " + _toDisplayString(_unref(t)("Flow.SkillGenerated")), 1)
                                              ]),
                                              _: 1
                                            })
                                          ])
                                        ]),
                                        _: 1
                                      }, 8, ["content"]))
                                    : (isAnyChange.value)
                                      ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                                          key: 1,
                                          content: _unref(t)('Flow.GenerateSkillUnsavedChanges'),
                                          placement: "top"
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", null, [
                                              _createVNode(_unref(ElButton), {
                                                size: "small",
                                                type: "button",
                                                disabled: true
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_font_awesome_icon, {
                                                    icon: skillExists.value ? 'sync' : 'magic',
                                                    class: "margin-right-5"
                                                  }, null, 8, ["icon"]),
                                                  _createTextVNode(" " + _toDisplayString(skillExists.value
                            ? _unref(t)("Flow.UpdateSkill")
                            : _unref(t)("Flow.GenerateSkill")), 1)
                                                ]),
                                                _: 1
                                              })
                                            ])
                                          ]),
                                          _: 1
                                        }, 8, ["content"]))
                                      : (_openBlock(), _createBlock(_unref(ElButton), {
                                          key: 2,
                                          size: "small",
                                          type: "button",
                                          loading: isGeneratingSkill.value,
                                          disabled: responseLoading.value || !canGenerateSkill.value,
                                          onClick: onGenerateSkill
                                        }, {
                                          default: _withCtx(() => [
                                            (!isGeneratingSkill.value)
                                              ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                                  key: 0,
                                                  icon: skillExists.value ? 'sync' : 'magic',
                                                  class: "margin-right-5"
                                                }, null, 8, ["icon"]))
                                              : _createCommentVNode("", true),
                                            _createTextVNode(" " + _toDisplayString(isGeneratingSkill.value
                        ? _unref(t)("Flow.Generating")
                        : skillExists.value
                        ? _unref(t)("Flow.UpdateSkill")
                        : _unref(t)("Flow.GenerateSkill")), 1)
                                          ]),
                                          _: 1
                                        }, 8, ["loading", "disabled"]))
                                ])
                              ], 64))
                            : _createCommentVNode("", true),
                          (flow.value.currentActivityStatus)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.CurrentActivityStatus")), 1),
                                _createElementVNode("div", _hoisted_53, [
                                  _createVNode(_unref(ElTag), {
                                    type: _unref(statusColor)(flow.value.currentActivityStatus)
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString(flow.value.currentActivityStatus), 1)
                                    ]),
                                    _: 1
                                  }, 8, ["type"])
                                ])
                              ]))
                            : _createCommentVNode("", true),
                          _hoisted_54,
                          _createElementVNode("div", _hoisted_55, [
                            (flow.value)
                              ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                                  key: 0,
                                  class: "scrollable-tooltip",
                                  effect: "custom",
                                  placement: "left"
                                }, {
                                  content: _withCtx(() => [
                                    _createElementVNode("div", {
                                      class: _normalizeClass([
                        'scrollable-tooltip-content',
                        {
                          'overflow-auto':
                            _unref(t)('Flow.FlowReportTooltip').length > 100,
                        },
                      ])
                                    }, _toDisplayString(_unref(t)("Flow.FlowReportTooltip")), 3)
                                  ]),
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ElCheckbox), {
                                      onChange: onFlowChange,
                                      modelValue: flow.value.sendFlowReport,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((flow.value.sendFlowReport) = $event)),
                                      label: "Send Activity Report on Each Completion",
                                      size: "large"
                                    }, null, 8, ["modelValue"])
                                  ]),
                                  _: 1
                                }))
                              : _createCommentVNode("", true)
                          ]),
                          (flow.value.sendFlowReport)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_56, [
                                _createElementVNode("div", _hoisted_57, [
                                  _hoisted_58,
                                  _createVNode(_unref(ElInput), {
                                    onInput: onFlowChange,
                                    modelValue: flow.value.notifyUsers,
                                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((flow.value.notifyUsers) = $event)),
                                    onKeyup: _cache[18] || (_cache[18] = ($event: any) => (handleEmails(flow.value.notifyUsers))),
                                    size: "small",
                                    placeholder: "Enter emails separated by ;"
                                  }, null, 8, ["modelValue"]),
                                  _createElementVNode("div", _hoisted_59, _toDisplayString(invalidEmail.value), 1)
                                ]),
                                _createVNode(_unref(ElCheckbox), {
                                  onChange: onFlowChange,
                                  modelValue: flow.value.onSuccess,
                                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((flow.value.onSuccess) = $event)),
                                  label: "On Success",
                                  size: "large",
                                  disabled: !flow.value.notifyUsers
                                }, null, 8, ["modelValue", "disabled"]),
                                _createVNode(_unref(ElCheckbox), {
                                  onChange: onFlowChange,
                                  modelValue: flow.value.onError,
                                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((flow.value.onError) = $event)),
                                  label: "On Error",
                                  size: "large",
                                  disabled: !flow.value.notifyUsers
                                }, null, 8, ["modelValue", "disabled"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ])
                    ], 6))
                  : _createCommentVNode("", true),
                (userVariableVisible.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 2,
                      ref_key: "userVarsBoxRef",
                      ref: userVarsBoxRef,
                      class: _normalizeClass(["background-fb z-index-15", [{ 'drawer-visible': userVariableVisible.value }]]),
                      style: _normalizeStyle({
            width: currentEditStepWidthPx.value + 'px',
            minWidth: minEditStepWidth.value + 'px',
            maxWidth: '1500px',
          })
                    }, [
                      _createElementVNode("div", {
                        id: "resize",
                        class: "resize-item",
                        onPointerdown: startResize
                      }, null, 32),
                      _createElementVNode("div", _hoisted_60, [
                        _createElementVNode("div", _hoisted_61, [
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-link",
                            id: "close-info",
                            onClick: showUserVariables
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "times" })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("strong", null, _toDisplayString(_unref(t)("Common.CustomFieldDefinitions")), 1),
                            _createElementVNode("div", _hoisted_64, [
                              _createVNode(_unref(ElButton), {
                                class: "no-border btn-oneTeg2",
                                size: "mini",
                                type: "primary",
                                onClick: _cache[21] || (_cache[21] = ($event: any) => (addUserDefinedVariables()))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_font_awesome_icon, { icon: "plus" })
                                ]),
                                _: 1
                              })
                            ])
                          ]),
                          (userDefinedVariables.value.length > 0)
                            ? (_openBlock(), _createBlock(_unref(ElDivider), {
                                key: 0,
                                style: {"margin":"10px 0"}
                              }))
                            : _createCommentVNode("", true),
                          (userDefinedVariables.value.length > 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_65, [
                                _createElementVNode("span", _hoisted_66, _toDisplayString(_unref(t)("Common.Variable")), 1),
                                _createElementVNode("span", _hoisted_67, _toDisplayString(_unref(t)("Common.Value")), 1),
                                _hoisted_68
                              ]))
                            : _createCommentVNode("", true),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(userDefinedVariables.value, (item, index) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: index,
                              class: "d-flex align-items-start justify-content-center gap-2 full-width"
                            }, [
                              _createElementVNode("div", {
                                id: 'variable-' + index + '-div',
                                class: "d-flex flex-column margin-top-10 udv-field-column"
                              }, [
                                _createVNode(_unref(ElInput), {
                                  modelValue: item.value.itemKey,
                                  "onUpdate:modelValue": ($event: any) => ((item.value.itemKey) = $event),
                                  id: 'variable-input-' + index,
                                  onKeydown: preventLetters,
                                  onInput: 
                      (e) => updateUserDefinedVariables(e, 'itemKey', index)
                    ,
                                  size: "mini",
                                  class: "full-width"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "onInput"])
                              ], 8, _hoisted_69),
                              _createElementVNode("div", {
                                id: 'value-' + index + '-div',
                                class: "d-flex flex-column margin-top-10 udv-field-column"
                              }, [
                                _createVNode(_unref(ElInput), {
                                  modelValue: item.value.itemValue,
                                  "onUpdate:modelValue": ($event: any) => ((item.value.itemValue) = $event),
                                  id: 'value-input-' + index,
                                  onInput: 
                      (e) => updateUserDefinedVariables(e, 'itemValue', index)
                    ,
                                  size: "mini",
                                  class: "full-width"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "id", "onInput"])
                              ], 8, _hoisted_70),
                              _createElementVNode("div", _hoisted_71, [
                                _createElementVNode("button", {
                                  class: "btn btn-link icon-btn udv-action-btn",
                                  type: "button",
                                  onClick: ($event: any) => (removeUserDefinedVariables(index))
                                }, [
                                  _createVNode(_component_font_awesome_icon, { icon: "trash" })
                                ], 8, _hoisted_72)
                              ])
                            ]))
                          }), 128)),
                          _hoisted_73
                        ])
                      ])
                    ], 6))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("div", {
                  ref_key: "wizardBoxRef",
                  ref: wizardBoxRef,
                  id: "wizard-drawer-box",
                  class: _normalizeClass(["background-fb z-index-15", [{ 'drawer-visible': wizardDrawerVisible.value }]]),
                  style: _normalizeStyle({
            width: currentWizardWidthPx.value + 'px',
            minWidth: minWizardWidth.value + 'px',
            maxWidth: '1500px',
          })
                }, [
                  _createElementVNode("div", {
                    id: "resize-wizard",
                    class: "resize-item",
                    onPointerdown: startResize
                  }, null, 32),
                  _createVNode(WizardDrawer, {
                    ref_key: "wizardDrawerRef",
                    ref: wizardDrawerRef,
                    inline: "",
                    visible: wizardDrawerVisible.value,
                    "flow-id": flowId.value || undefined,
                    "flow-version": version.value ? Number(version.value) : undefined,
                    "flow-name": flow.value?.name || '',
                    "current-flow-snapshot": currentWizardFlowSnapshot.value,
                    "use-new-ui-editor": true,
                    "skill-generation-enabled": skillGenerationEnabled.value,
                    "auto-debug-context": wizardAutoDebugContext.value,
                    onClose: closeWizardDrawer,
                    onFlowCreated: handleWizardFlowCreated,
                    onHistoryVisibilityChange: handleWizardHistoryVisibilityChange,
                    onApprovalStateChanged: handleWizardApprovalStateChange,
                    onAnalysisStarted: handleWizardAnalysisStarted,
                    onAnalysisReady: handleWizardAnalysisReady
                  }, null, 8, ["visible", "flow-id", "flow-version", "flow-name", "current-flow-snapshot", "skill-generation-enabled", "auto-debug-context"])
                ], 6), [
                  [_vShow, wizardDrawerVisible.value]
                ]),
                (conditionVisible.value && selectedStep.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 3,
                      ref_key: "conditionBoxRef",
                      ref: conditionBoxRef,
                      id: "condition-box",
                      class: _normalizeClass(["background-fb z-index-15", [
            {
              'drawer-visible': conditionVisible.value,
              'function-drawer-open': functionsVisible.value && !expressionDrawer.value,
              'function-expression-drawer-open':
                functionsVisible.value && expressionDrawer.value,
              'function-drawer-close': !functionsVisible.value,
            },
          ]]),
                      style: _normalizeStyle({
            width: currentConditionWidthPx.value + 'px',
            minWidth: minConditionWidth.value + 'px',
            maxWidth: '1500px',
          })
                    }, [
                      _createElementVNode("div", {
                        id: "resize-condition",
                        class: "resize-item",
                        onPointerdown: startResize
                      }, null, 32),
                      _createElementVNode("div", {
                        class: _normalizeClass(["card card-drawer background-fb filter-condition-card", `oneteg-drawer-${getSizeByValue(filterSize.value)}`])
                      }, [
                        _createElementVNode("div", _hoisted_74, [
                          _createTextVNode(_toDisplayString(_unref(t)("Common.Filter")) + " ", 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-link",
                            id: "condition-close",
                            onClick: _cache[22] || (_cache[22] = ($event: any) => (showCondition()))
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "times" })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_75, [
                          _createElementVNode("div", _hoisted_76, [
                            _createVNode(_unref(Condition), {
                              conditions: selectedStep.value.filter || [],
                              onOnChange: changeFilter,
                              "output-list": 
                    outputList.value.filter(
                      (item) =>
                        selectedStep.value.availableOutput.some(
                          (x) => x.uniqueId === item.uniqueId
                        ) || selectedStep.value.uniqueId === item.uniqueId
                    )
                  ,
                              "metaoutput-list": 
                    metaoutputList.value.filter(
                      (item) =>
                        selectedStep.value.availableMetaoutput.some(
                          (x) => x.uniqueId === item.uniqueId
                        ) || selectedStep.value.uniqueId === item.uniqueId
                    )
                  ,
                              "step-index": selectedIndex.value,
                              "id-suffix": '',
                              "user-defined-variables": userDefinedVariables.value,
                              "system-variables": systemVariables.value,
                              expressions: expressions.value,
                              onChangeFunctionsVisible: changeFunctionsVisible,
                              onChangesHappened: _cache[23] || (_cache[23] = ($event: any) => (updateStep(true))),
                              onClose: showCondition
                            }, null, 8, ["conditions", "output-list", "metaoutput-list", "step-index", "user-defined-variables", "system-variables", "expressions"])
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_77, [
                          _createElementVNode("button", {
                            class: "btn btn-link",
                            onClick: removeFilter
                          }, _toDisplayString(_unref(t)("Common.RemoveFilter")), 1),
                          _createVNode(_unref(ElButton), {
                            class: "btn-oneTeg3 filter-condition-close",
                            "native-type": "button",
                            size: "mini",
                            onClick: _cache[24] || (_cache[24] = ($event: any) => (showCondition()))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(t)("Common.Close")), 1)
                            ]),
                            _: 1
                          })
                        ])
                      ], 2)
                    ], 6))
                  : _createCommentVNode("", true),
                (routerVisible.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 4,
                      ref_key: "routerBoxRef",
                      ref: routerBoxRef,
                      class: _normalizeClass(["background-fb z-index-15", [
            {
              'drawer-visible': routerVisible.value,
              'function-drawer-open': functionsVisible.value && !expressionDrawer.value,
              'function-expression-drawer-open':
                functionsVisible.value && expressionDrawer.value,
              'function-drawer-close': !functionsVisible.value,
            },
          ]]),
                      id: "router-step-box",
                      style: _normalizeStyle({
            width: currentRouterWidthPx.value + 'px',
            minWidth: minRouterWidth.value + 'px',
            maxWidth: '1500px',
          })
                    }, [
                      _createElementVNode("div", {
                        id: "resize",
                        class: "resize-item",
                        onPointerdown: startResize
                      }, null, 32),
                      (_openBlock(), _createBlock(_unref(EditRoute), {
                        key: `router-${selectedStep.value?.origId}-${routerDrawerKey.value}`,
                        onClose: closeRouterSettings,
                        class: _normalizeClass(`oneteg-drawer-${getSizeByValue(routerSize.value)}`),
                        "is-new-ui": true,
                        step: selectedStep.value,
                        "step-index": selectedIndex.value,
                        flow: flow.value,
                        "output-list": routerOutputList(),
                        "user-defined-variables": userDefinedVariables.value,
                        "system-variables": systemVariables.value,
                        expressions: expressions.value,
                        "metaoutput-list": routerMetaoutputList(),
                        onOnChange: onRouterChange,
                        onChangeFunctionVisible: changeFunctionsVisible,
                        onCloseDrawer: closeRouterSettings,
                        onChangesHappened: _cache[25] || (_cache[25] = ($event: any) => (updateStep(true))),
                        onRemoveStep: removeStep,
                        onAddStepEdge: addStepEdge,
                        onRouteNameChange: updateRouteNameLabel
                      }, null, 8, ["class", "step", "step-index", "flow", "output-list", "user-defined-variables", "system-variables", "expressions", "metaoutput-list"]))
                    ], 6))
                  : _createCommentVNode("", true),
                (loopVisible.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 5,
                      class: _normalizeClass([[
            {
              'drawer-visible': loopVisible.value,
              'function-drawer-open': functionsVisible.value && !expressionDrawer.value,
              'function-expression-drawer-open':
                functionsVisible.value && expressionDrawer.value,
              'function-drawer-close': !functionsVisible.value,
            },
          ], "background-fb z-index-15"])
                    }, [
                      (_openBlock(), _createBlock(_unref(EditLoop), {
                        ref_key: "editLoopRef",
                        ref: editLoopRef,
                        key: `loop-${selectedStep.value?.origId}-${loopDrawerKey.value}`,
                        onClose: closeLoopSettings,
                        onOnChange: onLoopChange,
                        onCloseDrawer: closeLoopSettings,
                        size: loopSize.value,
                        class: _normalizeClass(`oneteg-drawer-${getSizeByValue(loopSize.value)}`),
                        step: selectedStep.value,
                        "step-list": steps.value,
                        "step-index": selectedIndex.value,
                        "output-list": outputList.value,
                        "step-simulating": stepSimulating.value,
                        metaoutputList: metaoutputList.value,
                        userDefinedVariables: userDefinedVariables.value,
                        "system-variables": systemVariables.value,
                        expressions: expressions.value,
                        onUpdateOutput: _cache[26] || (_cache[26] = ($event: any) => (updateEditFlow(false, true))),
                        onUpdateSimulate: _cache[27] || (_cache[27] = ($event: any) => (updateSimulating($event))),
                        onChangeFunctionVisible: changeFunctionsVisible,
                        onPredicateChange: changeFilter,
                        onPredicateChangesHappened: _cache[28] || (_cache[28] = ($event: any) => (updateStep(true))),
                        onAnalyzeWithWizard: handleAnalyzeWithWizard,
                        "wizard-enabled": aiWizardEnabled.value
                      }, null, 8, ["size", "class", "step", "step-list", "step-index", "output-list", "step-simulating", "metaoutputList", "userDefinedVariables", "system-variables", "expressions", "wizard-enabled"]))
                    ], 2))
                  : _createCommentVNode("", true),
                (delayVisible.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 6,
                      class: _normalizeClass([[{ 'drawer-visible': delayVisible.value }], "background-fb z-index-15"])
                    }, [
                      _createVNode(_unref(EditDelay), {
                        class: "oneteg-drawer-small",
                        name: selectedStep.value.name,
                        "existing-delay": selectedStep.value.delay,
                        onClose: openDelay,
                        onChange: changeDelay
                      }, null, 8, ["name", "existing-delay"])
                    ], 2))
                  : _createCommentVNode("", true),
                (configurationVisible.value && hasFlowSettings.value)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 7,
                      class: _normalizeClass([[{ 'drawer-visible': configurationVisible.value }], "background-fb z-index-15"])
                    }, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["card border-0 background-fb", `oneteg-drawer-${getSizeByValue(detailsSize.value)}`])
                      }, [
                        _createElementVNode("div", _hoisted_78, [
                          _createElementVNode("div", null, _toDisplayString(_unref(t)("Common.FlowSettings")), 1),
                          _createElementVNode("button", {
                            type: "button",
                            class: "btn btn-link",
                            id: "close-info",
                            onClick: showConfiguration
                          }, [
                            _createVNode(_component_font_awesome_icon, { icon: "times" })
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_79, [
                          (tree.value.length)
                            ? (_openBlock(), _createBlock(_unref(ElInput), {
                                key: 0,
                                modelValue: filterText.value,
                                "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => ((filterText).value = $event)),
                                size: "small",
                                style: {"margin-bottom":"10px"},
                                placeholder: _unref(t)('Common.Filter')
                              }, null, 8, ["modelValue", "placeholder"]))
                            : _createCommentVNode("", true),
                          _createVNode(_unref(ElScrollbar), { "max-height": '65vh' }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_80, [
                                _createVNode(_unref(ElTree), {
                                  ref_key: "treeRef",
                                  ref: treeRef,
                                  style: {"max-width":"500px"},
                                  data: tree.value,
                                  class: "filter-tree",
                                  props: defaultProps,
                                  "default-expand-all": "",
                                  "filter-node-method": filterNode
                                }, {
                                  default: _withCtx(({ data }) => [
                                    _createElementVNode("div", _hoisted_81, [
                                      (isTextLong(data.description))
                                        ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                                            key: 0,
                                            content: data.description,
                                            effect: "custom",
                                            placement: "top"
                                          }, {
                                            default: _withCtx(() => [
                                              _createElementVNode("span", null, _toDisplayString(data.description), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["content"]))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_82, _toDisplayString(data.description), 1)),
                                      (!data.children || data.children.length === 0)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_83, [
                                            (data.enumerationValues.length > 0)
                                              ? (_openBlock(), _createBlock(_unref(ElSelect), {
                                                  key: 0,
                                                  modelValue: data.inputValue,
                                                  "onUpdate:modelValue": ($event: any) => ((data.inputValue) = $event),
                                                  size: "small",
                                                  placeholder: "Select value",
                                                  id: 'select-' + data.label,
                                                  onChange: ($event: any) => (handleInputValueChange(data, $event))
                                                }, {
                                                  default: _withCtx(() => [
                                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.enumerationValues, (option) => {
                                                      return (_openBlock(), _createBlock(_unref(ElOption), {
                                                        key: option,
                                                        label: option,
                                                        value: option
                                                      }, null, 8, ["label", "value"]))
                                                    }), 128))
                                                  ]),
                                                  _: 2
                                                }, 1032, ["modelValue", "onUpdate:modelValue", "id", "onChange"]))
                                              : (_openBlock(), _createBlock(_unref(ElInput), {
                                                  key: 1,
                                                  modelValue: data.inputValue,
                                                  "onUpdate:modelValue": ($event: any) => ((data.inputValue) = $event),
                                                  size: "small",
                                                  placeholder: _unref(t)('Common.EnterValue'),
                                                  id: 'input-' + data.label,
                                                  onFocus: ($event: any) => (_ctx.handleInputFocus(data)),
                                                  onChange: ($event: any) => (handleInputChange(data))
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder", "id", "onFocus", "onChange"]))
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ]),
                                  _: 1
                                }, 8, ["data"])
                              ])
                            ]),
                            _: 1
                          })
                        ])
                      ], 2)
                    ], 2))
                  : _createCommentVNode("", true)
              ], 2))
            : _createCommentVNode("", true),
          (activeTab.value === 2)
            ? (_openBlock(), _createBlock(_unref(FlowVersions), {
                key: 1,
                onSwitch: switchFlow,
                onUpdateLoading: updateResponseLoading,
                onGoToEdit: setActiveOne,
                showClose: true
              }))
            : _createCommentVNode("", true),
          (activeTab.value === 3)
            ? (_openBlock(), _createBlock(_unref(Activities), {
                key: 2,
                showClose: true,
                onGoToEdit: setActiveOne
              }))
            : _createCommentVNode("", true),
          (aiWizardEnabled.value)
            ? (_openBlock(), _createBlock(TaggyPromo, {
                key: 3,
                "promo-hidden": isTeggyPromoHidden.value,
                "screen-key": taggyScreenKey.value,
                "screen-visible": isTaggySurfaceVisible.value,
                "wizard-open": wizardDrawerVisible.value,
                onHidePromo: handleHideTeggyPromo,
                onOpenWizard: openWizardDrawer
              }, null, 8, ["promo-hidden", "screen-key", "screen-visible", "wizard-open"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_84, [
            _createElementVNode("div", _hoisted_85, [
              (flowId.value)
                ? (_openBlock(), _createElementBlock("ul", _hoisted_86, [
                    _createElementVNode("li", {
                      id: "flow-tab-information",
                      class: _normalizeClass(["nav-item-border width-100", { 'active-flow-tab': infoVisible.value }]),
                      onClick: showInfo
                    }, [
                      _createVNode(_unref(ElTooltip), {
                        effect: 
                  flow.value.name !== undefined && flow.value.name !== ''
                    ? 'custom'
                    : 'customized'
                ,
                        content: _unref(t)('Common.Information'),
                        placement: "left"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_87, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "info",
                              class: "fa-fw",
                              size: "lg"
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["effect", "content"])
                    ], 2),
                    (hasFlowSettings.value)
                      ? (_openBlock(), _createElementBlock("li", {
                          key: 0,
                          class: _normalizeClass(["nav-item-border width-100", { 'active-flow-tab': configurationVisible.value }]),
                          onClick: showConfiguration
                        }, [
                          _createVNode(_unref(ElTooltip), {
                            effect: "custom",
                            content: _unref(t)('Common.FlowSettings'),
                            placement: "left"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("a", _hoisted_88, [
                                _createVNode(_component_font_awesome_icon, {
                                  icon: "cog",
                                  size: "lg"
                                })
                              ])
                            ]),
                            _: 1
                          }, 8, ["content"])
                        ], 2))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(tabList.value, (item) => {
                      return (_openBlock(), _createElementBlock("li", {
                        class: _normalizeClass(["nav-item-border width-100", {
                'active-flow-tab': activeTab.value === item.tab && !infoVisible.value,
              }]),
                        onClick: ($event: any) => (setActive(item.tab)),
                        key: item.tab
                      }, [
                        _createVNode(_unref(ElTooltip), {
                          effect: "custom",
                          content: item.tooltip,
                          placement: "left"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("a", _hoisted_90, [
                              _createVNode(_component_font_awesome_icon, {
                                icon: item.icon,
                                class: "fa-fw",
                                size: "lg"
                              }, null, 8, ["icon"])
                            ])
                          ]),
                          _: 2
                        }, 1032, ["content"])
                      ], 10, _hoisted_89))
                    }), 128))
                  ]))
                : (_openBlock(), _createElementBlock("ul", _hoisted_91, [
                    _createElementVNode("li", {
                      id: "flow-tab-information",
                      class: _normalizeClass(["nav-item-border width-100", { 'active-flow-tab': infoVisible.value }]),
                      onClick: showInfo
                    }, [
                      _createVNode(_unref(ElTooltip), {
                        effect: 
                  flow.value.name !== undefined && flow.value.name !== ''
                    ? 'custom'
                    : 'customized'
                ,
                        content: _unref(t)('Common.Information'),
                        placement: "left"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_92, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "info",
                              class: "fa-fw",
                              size: "lg"
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["effect", "content"])
                    ], 2)
                  ])),
              _createElementVNode("ul", _hoisted_93, [
                _createElementVNode("li", {
                  id: "flow-tab-custom-field-definitions",
                  class: _normalizeClass(["nav-item-border width-100", { 'active-flow-tab': userVariableVisible.value }]),
                  onClick: showUserVariables
                }, [
                  _createVNode(_unref(ElTooltip), {
                    effect: "custom",
                    content: _unref(t)('Common.CustomFieldDefinitions'),
                    placement: "left"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("a", _hoisted_94, [
                        _createVNode(_component_font_awesome_icon, {
                          icon: "dollar-sign",
                          size: "lg"
                        })
                      ])
                    ]),
                    _: 1
                  }, 8, ["content"])
                ], 2)
              ]),
              _createElementVNode("ul", _hoisted_95, [
                (aiWizardEnabled.value)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      id: "taggy-wizard-trigger",
                      class: _normalizeClass(["nav-item-border width-100", { 'active-flow-tab': wizardDrawerVisible.value }]),
                      onClick: openWizardDrawer
                    }, [
                      _createVNode(_unref(ElTooltip), {
                        effect: "custom",
                        content: _unref(t)('TeggyAssistant.Tooltip'),
                        placement: "left"
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("a", _hoisted_96, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "magic",
                              size: "lg"
                            })
                          ])
                        ]),
                        _: 1
                      }, 8, ["content"])
                    ], 2))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_97, [
                _createVNode(_unref(ElColorPicker), {
                  modelValue: backgroundColor.value,
                  "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((backgroundColor).value = $event)),
                  class: "margin-top-10",
                  size: "small",
                  "show-alpha": "",
                  predefine: predefinedColors.value
                }, null, 8, ["modelValue", "predefine"])
              ])
            ]),
            (activeTab.value === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                  (flowId.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_99, [
                        (showSimulateRegular.value)
                          ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                              key: 0,
                              effect: "custom",
                              content: _unref(t)('Flow.ProceedStep'),
                              placement: "left"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-link btn-simulate",
                                  id: "flow-simulate-step",
                                  disabled: stepSimulating.value || disableSimulateButton.value,
                                  onClick: _cache[31] || (_cache[31] = ($event: any) => (simulateSelectedStep(false)))
                                }, [
                                  _createVNode(_component_font_awesome_icon, { icon: "step-forward" })
                                ], 8, _hoisted_100)
                              ]),
                              _: 1
                            }, 8, ["content"]))
                          : _createCommentVNode("", true),
                        (showSimulateRouterChild.value)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                              _createVNode(_unref(ElTooltip), {
                                effect: "custom",
                                content: _unref(t)('Flow.ProceedStep'),
                                placement: "left"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-link btn-simulate",
                                    id: "flow-simulate-router-child-step",
                                    disabled: stepSimulating.value || disableSimulateButton.value,
                                    onClick: _cache[32] || (_cache[32] = ($event: any) => (simulateSelectedStep(false)))
                                  }, [
                                    _createVNode(_component_font_awesome_icon, { icon: "step-forward" })
                                  ], 8, _hoisted_101)
                                ]),
                                _: 1
                              }, 8, ["content"]),
                              _hoisted_102,
                              _createVNode(_unref(ElTooltip), {
                                effect: "custom",
                                content: _unref(t)('Flow.ProceedBypassStep'),
                                placement: "left"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-link btn-simulate",
                                    id: "flow-simulate-step-bypass",
                                    disabled: stepSimulating.value || disableSimulateButton.value,
                                    onClick: _cache[33] || (_cache[33] = ($event: any) => (simulateSelectedStep(true)))
                                  }, [
                                    _createVNode(_component_font_awesome_icon, {
                                      icon: "eject",
                                      style: {"rotate":"90deg"}
                                    })
                                  ], 8, _hoisted_103)
                                ]),
                                _: 1
                              }, 8, ["content"])
                            ], 64))
                          : _createCommentVNode("", true),
                        (showSimulateControls.value)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_104))
                          : _createCommentVNode("", true),
                        _createVNode(_unref(ElTooltip), {
                          effect: "custom",
                          content: _unref(t)('Flow.Run'),
                          placement: "left"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("button", {
                              type: "button",
                              class: _normalizeClass(["btn btn-link", { 'margin-top-10': stepSimulating.value }]),
                              id: "flow-draft-run",
                              disabled: stepSimulating.value,
                              onClick: _cache[34] || (_cache[34] = ($event: any) => (runFlow(flow.value.name)))
                            }, [
                              (!stepSimulating.value)
                                ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                    key: 0,
                                    icon: "play"
                                  }))
                                : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                                    key: 1,
                                    icon: "pause"
                                  }))
                            ], 10, _hoisted_105)
                          ]),
                          _: 1
                        }, 8, ["content"]),
                        _hoisted_106,
                        (canStopFlow.value)
                          ? (_openBlock(), _createBlock(_unref(ElTooltip), {
                              key: 3,
                              effect: "custom",
                              content: _unref(t)('Flow.Stop'),
                              placement: "left"
                            }, {
                              default: _withCtx(() => [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "btn btn-link margin-top-10",
                                  id: "flow-draft-stop",
                                  disabled: !canStopFlow.value || !stepSimulating.value,
                                  onClick: stopRunningFlow
                                }, [
                                  _createVNode(_component_font_awesome_icon, { icon: "stop" })
                                ], 8, _hoisted_107)
                              ]),
                              _: 1
                            }, 8, ["content"]))
                          : _createCommentVNode("", true),
                        _hoisted_108
                      ]))
                    : _createCommentVNode("", true),
                  _createVNode(_unref(ElTooltip), {
                    effect: "custom",
                    content: `${
              flow.value.latest ? _unref(t)('Common.Save') : _unref(t)('Flow.Revert')
            } (CTRL/COMMAND + S)`,
                    placement: "left"
                  }, {
                    default: _withCtx(() => [
                      (flow.value.latest)
                        ? (_openBlock(), _createElementBlock("button", {
                            key: 0,
                            id: "flow-save-button",
                            class: "btn btn-oneTeg2 margin-bottom-10",
                            onClick: onFlowSubmit,
                            disabled: isSubmitting.value || shortCutPressed.value
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "save",
                              class: "fa-fw",
                              size: "1x"
                            })
                          ], 8, _hoisted_109))
                        : (_openBlock(), _createElementBlock("button", {
                            key: 1,
                            id: "flow-revert-button",
                            class: "btn btn-oneTeg2 margin-bottom-10",
                            onClick: flowRevert,
                            disabled: shortCutPressed.value
                          }, [
                            _createVNode(_component_font_awesome_icon, {
                              icon: "undo",
                              class: "fa-fw",
                              size: "1x"
                            })
                          ], 8, _hoisted_110))
                    ]),
                    _: 1
                  }, 8, ["content"])
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_111, [
          _createElementVNode("img", {
            src: `${_unref(ASSETS_BASE_URL)}/${_unref(DEFAULT_LOGO)}.png`,
            alt: "Loading...",
            class: "loader-logo-40"
          }, null, 8, _hoisted_112)
        ], 512), [
          [_vShow, responseLoading.value || pageLoading.value || configResponseLoading.value]
        ]),
        (visibleOutputDailog.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_113, [
              _createVNode(_unref(OutputDataDialog), {
                dialog: visibleOutputDailog.value,
                outputData: showingStepOutputData.output,
                moved: false,
                title: `${showingStepOutputData.displayNumber}. Step's Output Data`,
                onClose: _cache[35] || (_cache[35] = ($event: any) => (visibleOutputDailog.value = false)),
                index: showingStepOutputData.displayNumber
              }, null, 8, ["dialog", "outputData", "title", "index"])
            ]))
          : _createCommentVNode("", true),
        (runFlowDialog.value)
          ? (_openBlock(), _createBlock(_unref(SimulateDialog), {
              key: 1,
              dialog: runFlowDialog.value,
              selectedBuffer: outputLogs.value,
              moved: false,
              flowName: flowName.value,
              stoppable: true,
              "activity-id": activityId.value,
              "wizard-enabled": aiWizardEnabled.value,
              onDownloadLogsAsText: _cache[36] || (_cache[36] = ($event: any) => (downloadLogsAsText(flow.value))),
              onClose: closeFlowDialog,
              onAnalyzeWithWizard: handleAnalyzeWithWizard
            }, null, 8, ["dialog", "selectedBuffer", "flowName", "activity-id", "wizard-enabled"]))
          : _createCommentVNode("", true),
        _hoisted_114
      ], 4))
    : _createCommentVNode("", true)
}
}

})